import {
  Box,
  Card,
  Grid,
  InputAdornment,
  TextField,
  Chip,
  Tooltip,
  autocompleteClasses,
} from '@mui/material';
import {
  ChangeEvent,
  useContext,
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from 'react';
import TitleText from '../../components/formlib/TitleText';
import Textinput from '../../components/formlib/Textinput';
import SelectComponent from '../../components/formlib/SelectComponent';
import DatePickerComponent from '../../components/formlib/DatePickerComponent';
import MediumTypography from '../../components/formlib/MediumTypography';
import AddressForm from '../../components/formlib/AddressForm';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import { Formik, FormikErrors, FormikProps } from 'formik';
import * as yup from 'yup';
import {
  EMAIL_REGEX,
  PREVIEW_DOCUMENT_EXTENSIONS,
  STORAGE_USER_ID_KEY,
  employeeTypes,
} from '../../services/Constant';
import { ReactComponent as DeleteAlertIcon } from '../../assets/images/deleteAlertIcon.svg';
import CustomBackArrow from '../../components/imagepickers/backArrow';
import dayjs, { Dayjs } from 'dayjs';
import { Address, EmployeeFormData, Program } from './types';
import {
  nameValidation,
  formatPhoneNumber,
} from '../../utils/formValidationUtil';
import { checkPermissionForFeature } from '../../utils/checkPermission';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Employee,
  EmployeeDisciplineHistory,
  LocalProgram,
  activitySheetCheck,
  fileDelete,
  getEmployeeById,
  updateEmployeeDataByAdmin,
  updateEmployeeDataByUser,
  uploadEmployeeProfileOrCredentialFile,
} from '../../services/configApi/employees/employeeServices';
import {
  OptionType,
  ResponseType,
  SignatureStateType,
  SignatureType,
  employeeRoles,
} from '../../utils/type';
import SnackBarComponent from '../../components/formlib/SnackBarComponent';
import { formatName } from '../../utils/nameUtils';
import './EditEmployeeScreen.css';
import { ReactComponent as DocIcon } from '../../assets/images/decIcon.svg';
import UploadButton from '../../components/formlib/UploadButton';
import { ReactComponent as CloseIcon } from '../../assets/images/x.svg';
import { extractFileExtension } from '../../utils/fileUtils';
import FilePreviewDialog from '../../components/formlib/modal/FilePreviewDialog';
import { ReactComponent as InfoIcon } from '../../assets/images/infoIcon.svg';
import ActionToolTip from '../../components/formlib/ActionToolTip';
import {
  ApiError,
  ApiMessage,
  isCustomError,
  UpdateEmployeeData,
} from '../../services/ApiResponseHandler';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import ModalPopup from '../../components/formlib/ModalPopup';
import MultipleAutocompleteSearch from '../../components/formlib/MultipleAutocompleteSearch';
import _, { debounce } from 'lodash';
import CheckBoxComponent from '../../components/formlib/CheckBoxComponent';
import EmployeeSignatureModal, {
  EmployeeSignatureType,
} from '../../components/formlib/modal/EmployeeSignatureModal';
import { ReactComponent as Editsignature } from '../../assets/images/editsignature.svg';
import { forgetPinApi, getSignature } from '../../services/SignatureApi';
import ResetPinModal from '../../components/formlib/modal/ResetPinModal';
import DropdownComponent from '../../components/formlib/DropdownComponent';
import AutocompleteSearch from '../../components/formlib/AutocompleteSearch';
import { getAllEmployeeMinimalList } from '../../services/ifspClient/IfspApi';
import {
  EMPLOYEE_DASHBOARD_ROUTE_NAME,
  EMPLOYEES_ROUTE_NAME,
  PROFILE_ROUTE_NAME,
} from '../../routes/Routing';
import OnBoardingEmployeeModal, { staffTypes } from './OnBoardingEmployeeModal';
import { datePickerMinDateMaxDateValidate } from '../../utils/dateUtil';
import { getAllGroupsAPIForOnBoarding } from '../../services/configApi/userGroups/userGroupServices';
import {
  isPointingToUAT,
  isSuperSuperAdmin,
  sanitizeDecimalInput,
} from '../../utils/utilities';

const WORKING_HOURS_REGEX = /^$|^\d{1,3}(\.\d{0,2})?$/;
import { LookUpContext } from '../../context/LookUpContextProvider';
import { UnSavedChangesContext } from '../../context/UnSavedChangesProvider';
import {
  DownloadClientFilesResponse,
  getClientFilesUrl,
} from '../../services/configApi/clientFiles/clientFilesProvider';
import { ReactComponent as TrashIcon } from '../../assets/images/trashIcon.svg';
import { v4 as uuidv4 } from 'uuid';

let isActivitySheetCheckRequiredDataChange = false;
let isProgramEndDateChange = false;
const initialValues: EmployeeFormData = {
  nameSuffix: '',
  id: '',
  clientId: '',
  kcUsername: '',
  firstName: '',
  middleName: '',
  lastName: '',
  preferredName: '',
  email: '',
  phoneNumber1: '',
  phoneNumber2: '',
  workingHours: '',
  productivityGoal: '0.00',
  allowProductivityGoalEdit: null,
  employeeRole: '',
  group: { id: '', groupName: '' },
  reportingTo: null,
  employeeType: null,
  employeeStartDate: null,
  employeeEndDate: null,
  employeeTypeStartDate: null,
  productivityGoalStartDate: null,
  lunchWaiverRequired: false,
  lunchWaiverStartDate: null,
  workingHoursPerWeekStartDate: null,
  superProgramId: '',
  programs: [
    {
      id: '',
      acronym: '',
      programId: '',
      editable: true,
      programName: '',
      programStartDate: null,
      programEndDate: null,
    },
  ],
  employeeCredentials: {
    credentialLicenseNumber: '',
    credentialExpirationDate: null,
    credentialFileUrl: '',
  },
  address1: {
    address1: '',
    address2: '',
    zipCode: '',
    city: { id: '', label: '' },
    state: '',
  },
  secondaryAddressRequired: false,
  address2: {
    address1: '',
    address2: '',
    zipCode: '',
    city: { id: '', label: '' },
    state: '',
  },
  emergencyContact: {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    address: {
      address1: '',
      address2: '',
      zipCode: '',
      city: { id: '', label: '' },
      state: '',
    },
  },
  signaturePartitionKey: '',
  signatureRowKey: '',
  phoneNumberExtension: '',
  phoneNumberExtension2: '',
  defaultProgram: '',
  disciplineType: null,
  signatureValue: null,
  npi: null,
  disciplineHistoryList: [
    {
      fId: '',
      id: '',
      disciplineType: '',
      credentialLicenseNumber: '',
      credentialExpirationDate: null,
      credentialFileUrl: '',
      startDate: null,
      isChanged: false,
      isDeleted: false,
    },
  ],
  rehireMonths: null,
  isRehireChecked: false,
};

const addressSchema = yup.object().shape({
  address1: yup.string().required('addressLine1RequiredMessage'),
  address2: yup.string(),
  zipCode: yup
    .string()
    .min(5, 'validZipCodeErrorMessage')
    .required('zipCodeRequiredMessage'),
  city: yup.object().shape({
    label: yup.string().required('cityRequiredMessage'),
  }),
  state: yup.string().required('stateRequiredMessage'),
});

const validationSchema = yup.object().shape({
  firstName: yup.string().required('CommunicationLogPage.fieldEmptyMessage'),
  lastName: yup.string().required('CommunicationLogPage.fieldEmptyMessage'),
  middleName: yup.string(),
  preferredName: yup
    .string()
    .required('CommunicationLogPage.fieldEmptyMessage'),
  email: yup
    .string()
    .matches(EMAIL_REGEX, 'EmailFormat.Validation')
    .required('SignIn.validation.emailRequired'),
  phoneNumber1: yup
    .string()
    .min(12, 'PhoneNumber.Validation')
    .required('CommunicationLogPage.fieldEmptyMessage'),
  phoneNumber2: yup.string().min(12, 'PhoneNumber.Validation'),
  isRehireChecked: yup.boolean().nullable(),

  rehireMonths: yup
    .string()
    .nullable()
    .when('isRehireChecked', {
      is: true,
      then: (schema) => schema.required('Months field is required.'),
    }),
  workingHours: yup
    .string()
    .required('CommunicationLogPage.fieldEmptyMessage')
    .test(
      'valid-hours-starting-balance',
      'workingHoursInValidErrorMessage',
      (value) => {
        if (!value) return false;

        let v = value.trim();

        v = v.replace(':', '.');
        if (v.startsWith('.')) v = `00${v}`;
        if (/^\d+\.$/.test(v)) v = v.replace('.', '.00');
        if (/^\d+$/.test(v)) v = v.padStart(2, '0') + '.00';

        const match = v.match(/^(\d{1,3})\.(\d{1,2})$/);
        if (!match) return false;

        const [, intRaw, decRaw] = match;

        const hours = Number(intRaw);
        let minutes = decRaw;

        if (hours > 99) return false;

        const allowed = ['00', '25', '50', '75'];

        if (!allowed.includes(minutes)) {
          if (minutes.length === 1) {
            minutes = minutes + '0'; // ".5" → ".50"
            if (!allowed.includes(minutes)) return false;
          } else {
            return false;
          }
        }

        const finalValue = Number(`${hours}.${minutes}`);

        if (finalValue > 120.0) return false;

        return true;
      },
    ),
  productivityGoal: yup
    .number()
    .min(0, 'minAllowedProductivityGoalErrorMessage')
    .max(100, 'maxAllowedProductivityGoalErrorMessage')
    .nullable(),
  allowProductivityGoalEdit: yup.boolean().nullable(),
  lunchWaiverRequired: yup.boolean(),
  lunchWaiverStartDate: yup
    .string()
    .when('employeeType', {
      is: (employeeType: string) => employeeType !== 'Salaried Exempt',
      then: (schema) =>
        schema.required('CommunicationLogPage.fieldEmptyMessage'),
      otherwise: (schema) => schema.nullable(),
    })
    .nullable(),
  reportingTo: yup
    .object()
    .shape({
      id: yup.string(),
      label: yup.string(),
    })
    .required('CommunicationLogPage.fieldEmptyMessage')
    .nullable(),
  group: yup
    .object()
    .shape({
      id: yup.string().required('CommunicationLogPage.fieldEmptyMessage'),
      groupName: yup
        .string()
        .required('CommunicationLogPage.fieldEmptyMessage'),
    })
    .nullable(),
  employeeRole: yup.string().required('employeeRole.DefaultProgram'),
  employeeType: yup.string().required('CommunicationLogPage.fieldEmptyMessage'),
  defaultProgram: yup.string().required('Please check a default program'),
  employeeTypeStartDate: yup
    .string()
    .required('CommunicationLogPage.fieldEmptyMessage'),
  productivityGoalStartDate: yup
    .string()
    .required('CommunicationLogPage.fieldEmptyMessage'),
  workingHoursPerWeekStartDate: yup
    .string()
    .required('CommunicationLogPage.fieldEmptyMessage'),
  programs: yup.array().of(
    yup.object().shape({
      programName: yup
        .string()
        .required('CommunicationLogPage.fieldEmptyMessage'),
      programStartDate: yup
        .string()
        .required('CommunicationLogPage.fieldEmptyMessage'),
    }),
  ),
  address1: addressSchema,
  secondaryAddressRequired: yup.boolean(),
  address2: yup.object().when('secondaryAddressRequired', {
    is: true,
    then: addressSchema,
    otherwise: yup.object(),
  }),
  emergencyContact: yup.object().shape({
    firstName: yup.string(),
    lastName: yup.string(),
    email: yup.string().matches(EMAIL_REGEX, 'EmailFormat.Validation'),
    phoneNumber: yup.string().min(12, 'PhoneNumber.Validation'),
    address: yup.object().shape({
      address1: yup.string(),
      address2: yup.string(),
      zipCode: yup.string().min(5, 'validZipCodeErrorMessage'),
      city: yup.object().shape({
        label: yup.string(),
      }),
      state: yup.string(),
    }),
  }),
  disciplineHistoryList: yup.array().of(
    yup.object().shape({
      disciplineType: yup.string().required('discipline.fieldEmptyMessage'),
      startDate: yup.string().when('disciplineType', {
        is: 'NA',
        then: (schema) => schema.nullable(),
        otherwise: (schema) =>
          schema.required('CommunicationLogPage.fieldEmptyMessage'),
      }),
    }),
  ),
  npi: yup.string().when('disciplineHistoryList', (list, schema) => {
    const hasNonNA = Array.isArray(list)
      ? list.some(
          (item) => item?.disciplineType && item.disciplineType !== 'NA',
        )
      : false;
    return hasNonNA
      ? schema.min(10, 'tenDigitNpiValidation').required('npiNumberValidation')
      : schema.nullable();
  }),
  signatureValue: yup
    .string()
    .required('Signature.fieldEmptyMessage')
    .nullable(),
});

const validateForm = (value: EmployeeFormData) => {
  const errors: Partial<EmployeeFormData> = {};

  if (value.employeeStartDate) {
    if (datePickerMinDateMaxDateValidate(value.employeeStartDate)) {
      errors.employeeStartDate = 'datePickerMinDateMaxDateValidate';
    }
  }

  if (value.employeeTypeStartDate) {
    if (datePickerMinDateMaxDateValidate(value.employeeTypeStartDate)) {
      errors.employeeTypeStartDate = 'datePickerMinDateMaxDateValidate';
    }
  }

  if (value.productivityGoalStartDate) {
    if (datePickerMinDateMaxDateValidate(value.productivityGoalStartDate)) {
      errors.productivityGoalStartDate = 'datePickerMinDateMaxDateValidate';
    }
  }

  if (value.workingHoursPerWeekStartDate) {
    if (datePickerMinDateMaxDateValidate(value.workingHoursPerWeekStartDate)) {
      errors.workingHoursPerWeekStartDate = 'datePickerMinDateMaxDateValidate';
    }
  }

  if (value.lunchWaiverStartDate) {
    if (datePickerMinDateMaxDateValidate(value.lunchWaiverStartDate)) {
      errors.lunchWaiverStartDate = 'datePickerMinDateMaxDateValidate';
    }
  }

  if (value.programs?.[0]?.programEndDate) {
    if (datePickerMinDateMaxDateValidate(value.programs[0].programEndDate)) {
      errors.programs = errors.programs ?? [];
      errors.programs[0] = errors.programs[0] ?? {};
      errors.programs[0].programEndDate = 'datePickerMinDateMaxDateValidate';
    }
    if (dayjs(value.programs[0].programEndDate).isAfter(dayjs())) {
      errors.programs = errors.programs ?? [];
      errors.programs[0] = errors.programs[0] ?? {};
      errors.programs[0].programEndDate = 'Program.endDateFutureError';
    }
    if (
      dayjs(value.programs[0].programEndDate).isBefore(
        value.programs[0].programStartDate,
      )
    ) {
      errors.programs = errors.programs ?? [];
      errors.programs[0] = errors.programs[0] ?? {};
      errors.programs[0].programEndDate = 'Program.endDateBeforeError';
    }
  }

  if (
    value.employeeTypeStartDate &&
    dayjs(value.employeeTypeStartDate).day() !== 0
  ) {
    errors.employeeTypeStartDate = 'onlySundayAllowed';
  }

  if (
    value.lunchWaiverStartDate &&
    dayjs(value.lunchWaiverStartDate).day() !== 0
  ) {
    errors.lunchWaiverStartDate = 'onlySundayAllowed';
  }

  if (
    value.productivityGoalStartDate &&
    dayjs(value.productivityGoalStartDate).day() !== 0
  ) {
    errors.productivityGoalStartDate = 'onlySundayAllowed';
  }

  if (
    value.workingHoursPerWeekStartDate &&
    dayjs(value.workingHoursPerWeekStartDate).day() !== 0
  ) {
    errors.workingHoursPerWeekStartDate = 'onlySundayAllowed';
  }

  if (value.employeeCredentials.credentialExpirationDate) {
    if (
      datePickerMinDateMaxDateValidate(
        value.employeeCredentials.credentialExpirationDate,
      )
    ) {
      errors.employeeCredentials = {
        credentialExpirationDate: 'datePickerMinDateMaxDateValidate',
        credentialFileUrl: '',
        credentialLicenseNumber: '',
      };
    }
  }
  value.programs.forEach((program, index) => {
    if (datePickerMinDateMaxDateValidate(program.programStartDate)) {
      errors.programs ??= [];
      if (!errors.programs[index]) {
        errors.programs[index] = {
          id: '',
          programName: '',
          programCode: '',
          programDirector: '',
          phoneNumber1: '',
          phoneNumber2: '',
          email: '',
          addressLine1: '',
          addressLine2: '',
          zipCode: '',
          city: { id: '', label: '' },
          state: '',
          faxNumber1: '',
          faxNumber2: '',
          acronym: '',
          programId: '',
          website: '',
          programImageId: '',
          programImageName: '',
          programImageUrl: '',
          isEdit: false,
          editable: false,
          programStartDate: '',
          programEndDate: '',
        };
      }
      errors.programs[index].programStartDate =
        'datePickerMinDateMaxDateValidate';
    }
  });

  value.programs.forEach((program, index) => {
    if (datePickerMinDateMaxDateValidate(program.programEndDate)) {
      errors.programs ??= [];
      if (!errors.programs[index]) {
        errors.programs[index] = {
          id: '',
          programName: '',
          programCode: '',
          programDirector: '',
          phoneNumber1: '',
          phoneNumber2: '',
          email: '',
          addressLine1: '',
          addressLine2: '',
          zipCode: '',
          city: { id: '', label: '' },
          state: '',
          faxNumber1: '',
          faxNumber2: '',
          acronym: '',
          programId: '',
          website: '',
          programImageId: '',
          programImageName: '',
          programImageUrl: '',
          isEdit: false,
          editable: false,
          programStartDate: '',
          programEndDate: '',
        };
      }
      errors.programs[index].programEndDate =
        'datePickerMinDateMaxDateValidate';
    }
  });

  value.programs.forEach((program, index) => {
    if (dayjs(program.programEndDate).isBefore(program.programStartDate)) {
      errors.programs ??= [];
      if (!errors.programs[index]) {
        errors.programs[index] = {
          id: '',
          programName: '',
          programCode: '',
          programDirector: '',
          phoneNumber1: '',
          phoneNumber2: '',
          email: '',
          addressLine1: '',
          addressLine2: '',
          zipCode: '',
          city: { id: '', label: '' },
          state: '',
          faxNumber1: '',
          faxNumber2: '',
          acronym: '',
          programId: '',
          website: '',
          programImageId: '',
          programImageName: '',
          programImageUrl: '',
          isEdit: false,
          editable: false,
          programStartDate: '',
          programEndDate: '',
        };
      }
    }
  });

  return errors;
};

interface FileAndUndefined {
  file: File | undefined;
}

interface FileAndIndex {
  file: File;
  index: number;
}

let localSelectedProgramId = '';

interface UnsavedChangesWatcherProps {
  values: EmployeeFormData;
  originalEmployeeData: EmployeeFormData;
  onUnsavedChangesChange: (hasUnsavedChanges: boolean) => void;
}

const UnsavedChangesWatcher = ({
  values,
  originalEmployeeData,
  onUnsavedChangesChange,
}: UnsavedChangesWatcherProps) => {
  useEffect(() => {
    if (_.isEqual(originalEmployeeData, values)) {
      onUnsavedChangesChange(false);
    } else {
      onUnsavedChangesChange(true);
    }
  }, [values]);

  return null;
};

const EditEmployeeScreen = () => {
  const location = useLocation();
  const [numOfPrograms, setNumOfPrograms] = useState<number>(0);
  const [employeeData, setEmployeeData] = useState<EmployeeFormData>();
  const [originalEmployeeData, setOriginalEmployeeData] =
    useState<EmployeeFormData>(initialValues);
  const formikRef = useRef<FormikProps<EmployeeFormData>>(null);
  const [successOrError, setSuccessOrError] = useState<ResponseType>('success');
  const [toastrId, setToastrId] = useState<string>();
  const [defaultMessage, setDefaultMessage] = useState<string>();
  const [programList, setProgramList] = useState<string[]>([]);
  const [errorEmail, setErrorEmail] = useState('');
  const [programAddressDetails, setProgramAddressDetails] = useState<
    LocalProgram[]
  >([]);
  const navigate = useNavigate();
  const [imagefileSelected] = useState<File>();
  const [showPreviewModel, setShowPreviewModel] = useState<boolean>(false);
  const { toggleLoader } = useContext(LoaderContext) as LoaderContextType;
  const { handleUpdateUnsavedChanges } = useContext(UnSavedChangesContext);
  const [openModal, setOpenModal] = useState(false);
  const fileUploadedRef = useRef<FileAndUndefined[]>();
  const isFileUploadedRef = useRef<boolean>(false);
  const isFileDeleted = useRef<boolean>(false);
  const isFileDeletedBeforeUploadRef = useRef<boolean>(false);
  const clickedIndex = useRef<number>(0);
  const [fileSelected, setFileSelected] = useState<FileAndUndefined[]>();
  const [clickedFile, setClickedFile] = useState<FileAndIndex>();
  const inputFileRef = useRef<(HTMLInputElement | null)[]>([]);
  const [addDesciplineEnable, setAddDesciplineEnable] = useState(true);
  const [openEmployeeSignature, setOpenEmployeeSignature] = useState(false);
  const signatureDetails = useRef<EmployeeSignatureType>({
    pin: '',
    employeeSignature: '',
  });
  const [employeeList, setEmployeeList] = useState<OptionType[]>([]);
  const signatureViewType = useRef<string>('');
  const [openResetModal, setOpenResetModal] = useState(false);
  const [screenFrom, setScreenFrom] = useState<string>('');
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const hasTierRangeAdjustmentEditPermission = checkPermissionForFeature(
    'backend.tier_range_adjustments',
    'editPermission',
  );
  const [defaultProgram, setDefaultProgram] = useState<string>('');
  const [groupsDropdown, setGroupsDropdown] = useState<OptionType[]>([]);
  const [disciplineList, setDisciplineList] = useState<OptionType[]>([]);
  const [openActivityCheckModal, setOpenActivityCheckModal] =
    useState<boolean>(false);
  const [activityCheckModalMessage, setActivityCheckModalMessage] =
    useState<string>('e4e5y5y');
  const [finalPayload, setFinalPayload] = useState<Employee>();
  const [checkApiCallErrorCode, setCheckApiCallErrorCode] =
    useState<ApiMessage>({
      code: 0,
      message: '',
      status: '',
      data: null,
    });

  const { lookups } = useContext(LookUpContext);
  const handleCancelAction = () => {
    formikRef.current?.resetForm();
    const initialProgram = originalEmployeeData.programs.filter(
      (item) => item.programId === employeeData?.defaultProgram,
    );
    setDefaultProgram(initialProgram[0]?.programId);
    setEmployeeData(originalEmployeeData);
    setNumOfPrograms(originalEmployeeData.programs.length);
  };

  const handleCheckboxChange = (values: EmployeeFormData, i: number) => {
    const newDefaultProgram = values.programs[i].programId;
    setDefaultProgram(values.programs[i].programId);

    const currectAddress = programAddressDetails.filter(
      (item) => item.programId === values.programs[i].programId,
    );
    const address: Address = {
      address1: currectAddress[0].addressLine1 ?? '',
      address2: currectAddress[0].addressLine2 ?? '',
      state: currectAddress[0].state ?? '',
      zipCode: currectAddress[0].zipCode ?? '',
      city: {
        id: 'asd',
        label: currectAddress[0].city ?? '',
      },
    };
    formikRef.current?.setValues({
      ...values,
      address1: address,
      defaultProgram: newDefaultProgram,
    });
  };

  useEffect(() => {
    if (lookups === null) {
      return;
    }

    setDisciplineList(() => {
      return lookups.employeeDiscipline?.map((e) => {
        return {
          label: e.description,
          id: e.code,
        };
      });
    });
  }, [lookups]);

  const constructPrograms = useMemo(
    () =>
      (programs: LocalProgram[] | null): Program[] => {
        if (programs === null || programs.length === 0) {
          return [
            {
              id: '',
              acronym: '',
              programName: '',
              editable: true,
              programId: '',
              programStartDate: null,
              programEndDate: null,
              staffType: null,
            },
          ];
        }

        return programs.map((program) => ({
          id: program.id,
          editable: false,
          programId: program.programId ?? '',
          acronym: program.acronym ?? '',
          programName: program.programName ?? '',
          programStartDate: program.startDate,
          programEndDate: program.endDate,
          staffType: program.staffType,
        }));
      },
    [],
  );

  const handleProgramChange = (
    value: string,
    i: number,
    values: EmployeeFormData,
  ) => {
    const pgs = [];
    values.programs.forEach((pg) => {
      if (pg.programName === value) {
        pgs.push(pg);
      }
    });
    if (pgs.length == 0) {
      formikRef.current?.setFieldValue(`programs.${i}.programName`, value);
    }
  };

  const getPrograms = useMemo(
    () =>
      (programs: Program[]): LocalProgram[] => {
        const newProgams: LocalProgram[] = [];
        programs.forEach((program) => {
          newProgams.push({
            id: program.id,
            acronym: program.acronym,
            programName: program.programName,
            programId: program.programId,
            staffType: program.staffType as string,
            startDate: program.programStartDate as string,
            endDate: program.programEndDate as string,
            // isRehireChecked: program.isRehireChecked,
            // rehireMonths: program.rehireMonths,
          });
        });
        return newProgams;
      },
    [],
  );

  const getPreferredName = (
    firstName: string | null,
    lastName: string | null | undefined,
    preferredName?: string | null,
  ): string => {
    if (preferredName) {
      return preferredName;
    }
    const finalPreferredName = `${firstName ?? ''}${
      lastName ? lastName.charAt(0).toUpperCase() : ''
    }`;
    return finalPreferredName.replace(/[^a-zA-Z]/g, '');
  };

  const handlePreviewClick = (index: number) => {
    clickedIndex.current = index;
    if (
      employeeData?.disciplineHistoryList?.[
        index
      ]?.credentialFileUrl?.startsWith('blob:http')
    ) {
      employeeData.employeeCredentials.credentialFileUrl =
        employeeData?.disciplineHistoryList[index]?.credentialFileUrl;
      setShowPreviewModel(true);
      return;
    } else if (!fileSelected?.[index]?.file) {
      return;
    }
    // getClientFilesUrl and update the licenseFile in employee
    let fileName = fileSelected?.[index]?.file?.name;
    if (!fileName) {
      fileName = '';
    }
    toggleLoader(true);
    getClientFilesUrl('credentials/'.concat(fileName))
      .then((response: DownloadClientFilesResponse) => {
        if (employeeData) {
          employeeData.employeeCredentials.credentialFileUrl = response.url;
          setShowPreviewModel(true);
        }
        toggleLoader(false);
      })
      .catch((error) => {
        toggleLoader(false);
        //display toaster
        setSuccessOrError('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setDefaultMessage(apiError.message);
        } else {
          setToastrId(error);
          setDefaultMessage(error);
        }
      });
  };

  const getEmployeeList = () => {
    toggleLoader(true);
    getAllEmployeeMinimalList()
      .then((response) => {
        const employees: OptionType[] = [];
        const emp = location.state.employee as Employee;
        response.forEach((empl) => {
          employees.push({
            id: empl.id,
            label: `${empl.lastName}, ${empl.firstName} - ${empl.email}`,
          });
          return employees;
        });
        setEmployeeList(employees);

        if (emp.reportingTo) {
          const foundEmp = employees.find((e) => e.id === emp.reportingTo);
          if (foundEmp) {
            getEmployeebyId(emp, foundEmp);
          } else {
            getEmployeebyId(emp, null);
          }
        } else {
          getEmployeebyId(emp, null);
        }
      })
      .catch((error) => {
        if (isCustomError(error)) {
          toggleLoader(false);
          setSuccessOrError('error');
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setDefaultMessage(apiError.message);
        } else {
          const emp = location.state as Employee;
          getEmployeebyId(emp, null);
        }
      });
  };

  useEffect(() => {
    if (
      location.state?.screenFrom !== undefined ||
      location.state?.screenFrom !== null
    ) {
      setScreenFrom(location.state?.screenFrom);
    }
    getEmployeeList();
  }, []);

  const handleDeleteProgram = (values: EmployeeFormData, i: number) => {
    values.programs = values.programs.filter((__, index) => index !== i);
    setEmployeeData(values);
    setNumOfPrograms(numOfPrograms - 1);
  };

  const getFormatedEmployee = (
    employee: Employee,
    reportee: OptionType | null,
  ) => {
    const employeeFormData: EmployeeFormData = {
      ...initialValues,
      isRehireChecked: employee.isRehireChecked,
      rehireMonths: employee.rehireMonths,
      nameSuffix: employee.nameSuffix,
      id: employee.id,
      group: { id: employee.group.id, groupName: employee.group.groupName },
      kcUsername: employee.kcUsername ?? '',
      firstName: employee.firstName ?? '',
      lastName: employee.lastName ?? '',
      middleName: employee.middleName ?? '',
      preferredName: getPreferredName(
        employee.firstName,
        employee.lastName,
        employee.preferredName,
      ),
      email: employee.email ?? '',
      phoneNumber1: employee.phone1 ?? '',
      phoneNumber2: employee.phone2 ?? '',
      workingHours: employee.workingHoursPerWeek ?? '0.00',
      productivityGoal:
        employee.productivityGoal === '' || employee.productivityGoal == null
          ? '0.00'
          : employee.productivityGoal,
      allowProductivityGoalEdit: employee.allowProductivityGoalEdit ?? null,
      employeeRole: employee.employeeRole ?? '',
      reportingTo: reportee,
      employeeType: employee.employeeType ?? null,
      employeeStartDate: employee.startDate,
      employeeEndDate: employee.endDate,
      programs: constructPrograms(employee.programs),
      address1: {
        address1: employee.primaryAddress1 ?? '',
        address2: employee.primaryAddress2 ?? '',
        zipCode: employee.primaryZipcode ?? '',
        city:
          employee.primaryCity !== null
            ? { id: 'aa', label: employee.primaryCity }
            : '',
        state: employee.primaryState ?? '',
      },
      address2: {
        address1: employee.secondaryAddress1 ?? '',
        address2: employee.secondaryAddress2 ?? '',
        zipCode: employee.secondaryZipcode ?? '',
        city:
          employee.secondaryCity !== null
            ? { id: 'aa', label: employee.secondaryCity }
            : '',
        state: employee.secondaryState ?? '',
      },
      secondaryAddressRequired: employee.secondaryAddressRequired,
      employeeTypeStartDate: employee.employeeTypeStartDate,
      productivityGoalStartDate: employee.productivityGoalStartDate,
      workingHoursPerWeekStartDate: employee.workingHoursPerWeekStartDate,
      lunchWaiverRequired: employee.lunchWaiverRequired ?? false,
      lunchWaiverStartDate: employee.lunchWaiverStartDate,
      emergencyContact: {
        firstName: employee.emergencyFirstName ?? '',
        lastName: employee.emergencyLastName ?? '',
        email: employee.emergencyEmail ?? '',
        phoneNumber: employee.emergencyPhone ?? '',
        address: {
          address1: employee.emergencyAddress1 ?? '',
          address2: employee.emergencyAddress2 ?? '',
          zipCode: employee.emergencyZipcode ?? '',
          city:
            employee.emergencyCity !== null
              ? { id: 'aa', label: employee.emergencyCity }
              : '',
          state: employee.emergencyState ?? '',
        },
      },
      employeeCredentials: {
        credentialLicenseNumber:
          employee.employeeCredentials?.credentialLicenseNumber,
        credentialExpirationDate:
          employee.employeeCredentials?.credentialExpirationDate,
        credentialFileUrl: employee.employeeCredentials?.credentialFileUrl,
      },
      signaturePartitionKey: employee.signaturePartitionKey,
      signatureRowKey: employee.signatureRowKey,
      phoneNumberExtension: employee.phoneNumberExtension,
      phoneNumberExtension2: employee.phoneNumberExtension2,
      defaultProgram: employee.defaultProgram,
      disciplineType: employee.disciplineType,
      npi: employee.npi,
      signatureValue: employee.signaturePartitionKey,
    } as EmployeeFormData;
    let disciplineHistoryListLocal: EmployeeDisciplineHistory[] = [];
    // map through disciplineHistoryList in employee and save to disciplineHistoryListLocal
    if (employee.disciplineHistoryList?.length) {
      disciplineHistoryListLocal = employee.disciplineHistoryList.map((d) => ({
        fId: d.fId ?? '',
        id: d.id ?? null,
        disciplineType: d.disciplineType ?? null,
        credentialLicenseNumber: d.credentialLicenseNumber ?? null,
        credentialExpirationDate: d.credentialExpirationDate ?? null,
        credentialFileUrl: d.credentialFileUrl ?? null,
        startDate: d.startDate ?? null,
        isChanged: d.isChanged ?? false,
        isDeleted: d.isDeleted ?? false,
      }));
    }
    employeeFormData.disciplineHistoryList = disciplineHistoryListLocal;

    return employeeFormData;
  };

  const getEmployeebyId = (
    employeeObject: Employee,
    reportee: OptionType | null,
  ) => {
    getEmployeeById(employeeObject.id)
      .then((employee: Employee) => {
        if (employee.signaturePartitionKey) {
          signatureDetails.current.employeeSignature = employee.signature;
        }
        if (employee.disciplineHistoryList) {
          const employeeCredfiles: FileAndUndefined[] = [];

          for (const d of employee.disciplineHistoryList) {
            inputFileRef.current.push(null);
            d.fId = uuidv4();
            d.isDeleted = false;

            if (d.credentialFileUrl) {
              const parts = d.credentialFileUrl.split('/');
              const uploadedFilename = parts[parts.length - 1];

              const filenameWithoutTimestamp = uploadedFilename.replace(
                /-\d{4}-\d{2}-\d{2}-\d{2}-\d{2}-\d{2}\.pdf$/,
                '.pdf',
              );

              const fakeFile = new File([new Blob()], filenameWithoutTimestamp);
              isFileDeletedBeforeUploadRef.current = true;

              employeeCredfiles.push({ file: fakeFile });
            } else {
              employeeCredfiles.push({ file: undefined });
            }
          }
          setFileSelected(employeeCredfiles);
          fileUploadedRef.current = employeeCredfiles;
        }

        const originalData = getFormatedEmployee(employee, reportee);

        const userId = localStorage.getItem(STORAGE_USER_ID_KEY);
        const programs: string[] = [];
        if (employee.programs !== null) {
          employee.programs.forEach((program) => {
            if (program.programName) {
              programs.push(program.programName);
            }
          });
        }
        if (employee.programs !== null)
          setProgramAddressDetails(employee.programs);
        setProgramList(programs);
        setNumOfPrograms(originalData.programs.length);
        setEmployeeData(originalData);
        setOriginalEmployeeData(originalData);
        setIsAdmin(userId !== originalData.id);
        return getAllGroupsAPIForOnBoarding();
      })
      .then((response) => {
        const groupsForDropdown: OptionType[] = [];

        const selectedProgram = localStorage.getItem('selectedProgram');
        const superProgramId = localStorage.getItem('superProgramId');

        if (selectedProgram) {
          localSelectedProgramId = JSON.parse(selectedProgram).id;
        }

        response.groups.forEach((group) => {
          if (
            (localSelectedProgramId &&
              localSelectedProgramId === superProgramId) ||
            group.createdBy !== 'Default' ||
            group.level !== 1
          ) {
            groupsForDropdown.push({
              id: group.id,
              label: group.groupName,
            });
          }
          return group;
        });
        setGroupsDropdown(groupsForDropdown);
        toggleLoader(false);
      })
      .catch((error) => {
        // Handle errors for the first API call
        toggleLoader(false);
        if (isCustomError(error)) {
          setSuccessOrError('error');
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setDefaultMessage(apiError.message);
        } else {
          const errorMessage = error as ApiMessage;
          if (errorMessage.code === 404) {
            const originalData = getFormatedEmployee(employeeObject, reportee);
            const userId = localStorage.getItem(STORAGE_USER_ID_KEY);
            setNumOfPrograms(originalData.programs.length);
            setEmployeeData(originalData);
            setOriginalEmployeeData(originalData);
            setIsAdmin(userId !== originalData.id);
          } else {
            setSuccessOrError('error');
            setToastrId('employeeError');
            setDefaultMessage('Failed to fetch employee details');
          }
        }
      })
      .catch((error) => {
        toggleLoader(false);
        setSuccessOrError('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setDefaultMessage(apiError.message);
        } else {
          setToastrId('employeeError');
          setDefaultMessage('Failed to Fetch Data');
        }
      });
  };

  const handleSubmission = useCallback(
    debounce((values: EmployeeFormData) => {
      toggleLoader(true);
      setEmployeeData(values);
      setOriginalEmployeeData(values);
      updateEmployeeForm(JSON.parse(JSON.stringify(values)));
    }, 500),
    [],
  );

  const updateEmployeeForm = (values: EmployeeFormData) => {
    const employee: Employee = {
      nameSuffix: values.nameSuffix,
      id: values.id,
      clientId: values.clientId,
      kcUsername: values.kcUsername,
      firstName: values.firstName,
      lastName: values.lastName,
      middleName: values.middleName,
      preferredName: values.preferredName,
      email: values.email,
      phone1: values.phoneNumber1,
      phone2: values.phoneNumber2,
      workingHoursPerWeek: values.workingHours,
      productivityGoal: values.productivityGoal,
      allowProductivityGoalEdit: values.allowProductivityGoalEdit,
      employeeRole: values.employeeRole,
      employeeTypeStartDate: values.employeeTypeStartDate,
      productivityGoalStartDate: values.productivityGoalStartDate,
      workingHoursPerWeekStartDate: values.workingHoursPerWeekStartDate,
      lunchWaiverRequired: values.lunchWaiverRequired,
      lunchWaiverStartDate: values.lunchWaiverStartDate,
      reportingTo:
        values.reportingTo !== null
          ? (values.reportingTo as OptionType).id
          : null,
      employeeType: values.employeeType,
      group: {
        id: values.group.id,
        groupName: values.group.groupName,
      },
      rehireMonths: values.rehireMonths ?? null,
      isRehireChecked: values.isRehireChecked,
      startDate: values.employeeStartDate as string,
      endDate: values.employeeEndDate as string,
      primaryAddress1: values.address1.address1,
      primaryAddress2: values.address1.address2,
      primaryZipcode: values.address1.zipCode,
      primaryCity: (values.address1.city as OptionType).label,
      primaryState: values.address1.state,
      secondaryAddressRequired: values.secondaryAddressRequired,
      secondaryAddress1:
        values.secondaryAddressRequired === true
          ? values.address2.address1
          : '',
      secondaryAddress2:
        values.secondaryAddressRequired === true
          ? values.address2.address2
          : '',
      secondaryCity:
        values.secondaryAddressRequired === true
          ? (values.address2.city as OptionType).label
          : '',
      secondaryZipcode:
        values.secondaryAddressRequired === true ? values.address2.zipCode : '',
      secondaryState:
        values.secondaryAddressRequired === true ? values.address2.state : '',
      emergencyFirstName: values.emergencyContact.firstName,
      emergencyLastName: values.emergencyContact.lastName,
      emergencyPhone: values.emergencyContact.phoneNumber,
      emergencyEmail: values.emergencyContact.email,
      emergencyAddress1: values.emergencyContact.address.address1,
      emergencyAddress2: values.emergencyContact.address.address2,
      emergencyZipcode: values.emergencyContact.address.zipCode,
      emergencyCity: (values.emergencyContact.address.city as OptionType).label,
      emergencyState: values.emergencyContact.address.state,
      superProgramId: values.superProgramId,
      programs: getPrograms(values.programs),
      name: '',
      status: null,
      allowDelete: null,
      employeeCredentials: {
        credentialLicenseNumber:
          values.employeeCredentials?.credentialLicenseNumber,
        credentialExpirationDate:
          values.employeeCredentials?.credentialExpirationDate,
        credentialFileUrl: values.employeeCredentials?.credentialFileUrl,
      },
      signature: signatureDetails.current.employeeSignature,
      pin:
        signatureDetails.current.pin !== ''
          ? signatureDetails.current.pin
          : null,
      signaturePartitionKey: values.signaturePartitionKey,
      signatureRowKey: values.signatureRowKey,
      phoneNumberExtension: values.phoneNumberExtension,
      phoneNumberExtension2: values.phoneNumberExtension2,
      defaultProgram: values.defaultProgram,
      disciplineType: values.disciplineType,
      npi: values.npi,
      activitySheetUpdated: isActivitySheetCheckRequiredDataChange,
      endDateUpdated: isProgramEndDateChange,
    };
    employee.disciplineHistoryList = values.disciplineHistoryList?.map(
      (item) => ({
        ...item,
        startDate: item.startDate
          ? dayjs(item.startDate).format('YYYY-MM-DD')
          : null,
        credentialExpirationDate:
          item.credentialExpirationDate &&
          item.credentialExpirationDate !== null &&
          item.credentialExpirationDate !== ''
            ? dayjs(item.credentialExpirationDate).format('YYYY-MM-DD')
            : null,
      }),
    );

    setFinalPayload(employee);
    const tempFile: File | null = (() => {
      const lastUploadedFile =
        fileUploadedRef.current && fileUploadedRef.current.length > 0
          ? fileUploadedRef.current[fileUploadedRef.current.length - 1].file
          : undefined;
      return lastUploadedFile ?? null;
    })();
    const tempImageFile: File | null =
      imagefileSelected !== undefined ? imagefileSelected : null;

    if (isFileUploadedRef.current === true && !isFileDeleted.current === true) {
      updateEmployee(tempImageFile, tempFile, employee);
    } else if (
      isFileDeleted.current === true &&
      isFileUploadedRef.current === false &&
      employee?.disciplineHistoryList &&
      employee?.disciplineHistoryList?.length > 0 &&
      employee?.disciplineHistoryList?.[
        employee?.disciplineHistoryList?.length - 1
      ].id &&
      employee?.disciplineHistoryList?.[
        employee?.disciplineHistoryList?.length - 1
      ].id !== null &&
      employee?.disciplineHistoryList?.[
        employee?.disciplineHistoryList?.length - 1
      ].id !== ''
    ) {
      const lastDisciplineId = employee.disciplineHistoryList[
        employee.disciplineHistoryList.length - 1
      ].id as string;
      fileDelete(employee.id, false, isFileDeleted.current, lastDisciplineId)
        .then(() => {
          updateEmployee(tempImageFile, tempFile, employee);
        })
        .catch((error) => {
          toggleLoader(false);
          setSuccessOrError('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setDefaultMessage(apiError.message);
          } else {
            setToastrId('employeefiledeletefail');
            setDefaultMessage('employeefiledeletefail');
          }
        });
    } else if (
      isFileDeleted.current === true &&
      isFileUploadedRef.current === true &&
      employee?.disciplineHistoryList &&
      employee?.disciplineHistoryList?.length > 0 &&
      employee?.disciplineHistoryList?.[
        employee?.disciplineHistoryList?.length - 1
      ].id &&
      employee?.disciplineHistoryList?.[
        employee?.disciplineHistoryList?.length - 1
      ].id !== null &&
      employee?.disciplineHistoryList?.[
        employee?.disciplineHistoryList?.length - 1
      ].id !== ''
    ) {
      const lastDisciplineId = employee.disciplineHistoryList[
        employee.disciplineHistoryList.length - 1
      ].id as string;
      fileDelete(employee.id, false, isFileDeleted.current, lastDisciplineId)
        .then(() => {
          updateEmployee(tempImageFile, tempFile, employee);
        })
        .catch((error) => {
          setSuccessOrError('error');
          toggleLoader(false);
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setDefaultMessage(apiError.message);
          } else {
            setToastrId('employeefiledeletefail');
            setDefaultMessage('Failed to delete file');
          }
        });
    } else if (
      isFileDeletedBeforeUploadRef.current === true &&
      isFileDeleted.current === true
    ) {
      updateEmployee(tempImageFile, tempFile, employee);
    } else {
      updateEmployee(tempImageFile, tempFile, employee);
    }
  };

  const uploadFileEmployee = (
    credFile: File | null,
    tempFile: File | null,
    employee: Employee,
    isAdminUpdate: boolean,
    disciplineId: string | null | undefined,
  ) => {
    uploadEmployeeProfileOrCredentialFile(
      credFile,
      tempFile,
      employee.id,
      disciplineId,
    )
      .then(() => {
        if (isAdminUpdate) {
          completeUpdateByAdmin();
        } else {
          completeUpdateByUser();
        }
      })
      .catch((error) => {
        toggleLoader(false);
        setSuccessOrError('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setDefaultMessage(apiError.message);
        } else {
          setToastrId('employeeFileUploadFailure');
          setDefaultMessage('Failed to Upload File');
        }
      });
  };

  const completeUpdateByUser = () => {
    toggleLoader(false);
    isFileDeleted.current = false;
    formikRef.current?.resetForm();
    setOpenActivityCheckModal(false);
    setActivityCheckModalMessage('');
    setSuccessOrError('success');
    setToastrId('updateSuccessMessage');
    const selectedProgreamId: string = JSON.parse(
      localStorage.getItem('selectedProgram') ?? '{}',
    ).id;
    if (localStorage.getItem(selectedProgreamId)) {
      setTimeout(() => {
        navigate(
          screenFrom === 'employeeList' ||
            location.state?.screenFrom === 'employeeList'
            ? EMPLOYEES_ROUTE_NAME
            : PROFILE_ROUTE_NAME,
        );
      }, 1000);
    } else {
      setTimeout(() => {
        navigate(EMPLOYEE_DASHBOARD_ROUTE_NAME);
      }, 1000);
    }
  };

  const completeUpdateByAdmin = () => {
    toggleLoader(false);
    isFileDeleted.current = false;
    formikRef.current?.resetForm();
    setOpenActivityCheckModal(false);
    setActivityCheckModalMessage('');
    isActivitySheetCheckRequiredDataChange = false;
    isProgramEndDateChange = false;
    setSuccessOrError('success');
    setToastrId('updateSuccessMessage');
    const selectedProgreamId: string = JSON.parse(
      localStorage.getItem('selectedProgram') ?? '{}',
    ).id;
    if (localStorage.getItem(selectedProgreamId)) {
      setTimeout(() => {
        navigate(
          screenFrom === 'employeeList' ||
            location.state?.screenFrom === 'employeeList'
            ? EMPLOYEES_ROUTE_NAME
            : PROFILE_ROUTE_NAME,
        );
      }, 1000);
    } else {
      setTimeout(() => {
        navigate(EMPLOYEE_DASHBOARD_ROUTE_NAME);
      }, 1000);
    }
  };

  const updateEmployeeByAdmin = (
    credFile: File | null,
    tempFile: File | null,
    employee: Employee,
  ) => {
    updateEmployeeDataByAdmin(employee)
      .then((response: UpdateEmployeeData) => {
        if (isFileUploadedRef.current === true) {
          uploadFileEmployee(
            credFile,
            tempFile,
            employee,
            true,
            response.data?.disciplineHistoryRecordId,
          );
        } else {
          completeUpdateByAdmin();
        }
      })
      .catch((error) => {
        toggleLoader(false);
        setSuccessOrError('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setDefaultMessage(apiError.message);
        } else {
          const response = error as ApiMessage;
          if (
            response.code === 1121 ||
            response.code === 1154 ||
            response.code === 1155 ||
            response.code === 1156 ||
            response.code === 1157 ||
            response.code === 1158 ||
            response.code === 1159 ||
            response.code === 1160 ||
            response.code === 1161 ||
            response.code === 1180 ||
            response.code === 1178
          ) {
            setToastrId(error.message);
            setDefaultMessage(error.message);
          } else {
            setDefaultMessage('Failed to update employee details');
            setToastrId('updateFailureMessage');
          }
        }
      });
  };

  const updateEmployeeByUser = (
    credFile: File | null,
    tempFile: File | null,
    employee: Employee,
  ) => {
    updateEmployeeDataByUser(employee)
      .then((response: UpdateEmployeeData) => {
        if (isFileUploadedRef.current === true) {
          uploadFileEmployee(
            credFile,
            tempFile,
            employee,
            false,
            response.data?.disciplineHistoryRecordId,
          );
        } else {
          completeUpdateByUser();
        }
      })
      .catch((error) => {
        toggleLoader(false);
        setSuccessOrError('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setDefaultMessage(apiError.message);
        } else {
          const response = error as ApiMessage;
          if (
            response.code === 1121 ||
            response.code === 1154 ||
            response.code === 1155 ||
            response.code === 1156 ||
            response.code === 1157 ||
            response.code === 1158 ||
            response.code === 1159 ||
            response.code === 1160 ||
            response.code === 1161 ||
            response.code === 1180 ||
            response.code === 1178
          ) {
            setToastrId(error.message);
            setDefaultMessage(error.message);
          } else {
            setDefaultMessage('Failed to update employee details');
            setToastrId('updateFailureMessage');
          }
        }
      });
  };

  const updateEmployee = (
    credFile: File | null,
    tempFile: File | null,
    employee: Employee,
  ) => {
    const userId = localStorage.getItem(STORAGE_USER_ID_KEY);
    if (isActivitySheetCheckRequiredDataChange || isProgramEndDateChange) {
      activitySheetCheck(employee)
        .then(() => {
          if (userId !== employee.id) {
            updateEmployeeByAdmin(credFile, tempFile, employee);
          } else {
            updateEmployeeByUser(credFile, tempFile, employee);
          }
        })
        .catch((error) => {
          toggleLoader(false);
          setSuccessOrError('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setDefaultMessage(apiError.message);
          } else {
            const response = error as ApiMessage;
            setCheckApiCallErrorCode(response);
            if (
              response.code === 1125 ||
              response.code === 1134 ||
              response.code === 1135
            ) {
              setActivityCheckModalMessage(response.message);
              setOpenActivityCheckModal(true);
            } else if (response.code === 1133 || response.code === 1145) {
              setToastrId(error.message);
              setDefaultMessage(error.message);
            } else {
              setDefaultMessage('Failed to update employee details');
              setToastrId('updateFailureMessage');
            }
          }
        });
    } else if (userId !== employee.id) {
      updateEmployeeByAdmin(credFile, tempFile, employee);
    } else {
      updateEmployeeByUser(credFile, tempFile, employee);
    }
  };

  const getEmployeeName = () => {
    if (employeeData) {
      return formatName(
        employeeData.firstName,
        null,
        employeeData.lastName,
        null,
      );
    }
    return '';
  };

  const onChipDelete = (index: number) => {
    if (fileSelected) {
      const fileSelectedCopy = [...fileSelected];
      fileSelectedCopy[index].file = undefined;
      setFileSelected(fileSelectedCopy);
    }

    if (fileUploadedRef?.current) {
      fileUploadedRef.current[index].file = undefined;
    }

    if (isFileDeletedBeforeUploadRef.current === true) {
      isFileDeleted.current = true;
    } else {
      isFileUploadedRef.current = false;
      isFileDeleted.current = false;
    }
    if (inputFileRef.current[index]) {
      inputFileRef.current[index] = null;
    }
    setClickedFile(undefined);
  };

  const handleFileChange = (
    event: ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const selectedFile =
      event.target.files !== null && event.target.files.length > 0
        ? event.target.files[0]
        : null;
    if (selectedFile !== null) {
      if (
        fileUploadedRef.current &&
        fileSelected &&
        selectedFile.type === 'application/pdf' &&
        selectedFile.size <= 5242880 &&
        selectedFile.size !== 0
      ) {
        fileUploadedRef.current[index] = { file: selectedFile };
        fileSelected[index].file = selectedFile;
        setFileSelected([...fileSelected]);
        setClickedFile({ file: selectedFile, index: index });
        isFileUploadedRef.current = true;
        if (employeeData?.disciplineHistoryList) {
          employeeData.disciplineHistoryList[index].credentialFileUrl =
            URL.createObjectURL(selectedFile);
          employeeData.disciplineHistoryList[index].isChanged = true;
          setEmployeeData({ ...employeeData });
        }
      } else {
        setSuccessOrError('error');
        setToastrId('pdfValidate');
        setDefaultMessage(
          'Please select a valid PDF file with a size of up to 5MB.',
        );
      }
    }
  };

  const browseFiles = (index: number) => {
    inputFileRef.current?.[index]?.click();
  };

  useEffect(() => {
    const checked = formikRef.current?.values.programs.filter(
      (item) => item.programId === employeeData?.defaultProgram,
    );
    if (checked && checked.length > 0) {
      setDefaultProgram(checked[0]?.programId);
    }
  }, [employeeData]);

  const licenseNumValidation = (value: string): string | undefined => {
    const trimmedValue = value?.replace(/^\s+/, '');
    const regex = /^[A-Za-z0-9!,'. ]*$/;
    if (regex.test(trimmedValue)) {
      return trimmedValue;
    }
  };

  const clearForm = () => {
    setOpenModal(false);
    handleCancelAction();
  };

  const fetchSiganture = () => {
    toggleLoader(true);
    let signatureObj: SignatureType[] = [];
    if (employeeData) {
      signatureObj = [
        {
          partitionkey: employeeData.signaturePartitionKey,
          id: employeeData.id,
          rowkey: employeeData.signatureRowKey,
        },
      ];
    }

    getSignature(signatureObj)
      .then((response: SignatureStateType[]) => {
        toggleLoader(false);
        signatureDetails.current.employeeSignature = response[0].signaturedata;
        setOpenEmployeeSignature(!openEmployeeSignature);
      })
      .catch((error) => {
        toggleLoader(false);
        setSuccessOrError('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setDefaultMessage(apiError.message);
        } else {
          setToastrId('sigantureFetchFail');
          setDefaultMessage('Failed To fetch signature');
        }
      });
  };

  const callForgotPinApi = () => {
    toggleLoader(true);

    let forgotPinEmployeeId: string = '';
    if (employeeData) {
      forgotPinEmployeeId = employeeData.id;
    }
    forgetPinApi(forgotPinEmployeeId)
      .then(() => {
        toggleLoader(false);
        setOpenResetModal(!openResetModal);
      })
      .catch((error) => {
        toggleLoader(false);
        setSuccessOrError('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setDefaultMessage(apiError.message);
        } else {
          setDefaultMessage(
            'Failed to Send Temporary Pin To Your Registered Email',
          );
          setToastrId('forgorApiErrorMesg');
        }
      });
  };

  const handleSuccess = (
    successerror: ResponseType,
    id: string,
    mes: string,
  ) => {
    setSuccessOrError(successerror);
    setToastrId(id);
    setDefaultMessage(mes);
  };

  const pinChangeCallback = (newPin: string) => {
    signatureDetails.current.pin = newPin;
  };

  const handleEmailChange = (e: string) => {
    const value = e;
    const emailRegex = /^[^\s@]{1,64}@[A-Za-z0-9.-]{1,255}\.[A-Za-z]{2,}$/;
    if (value !== '' && !emailRegex.test(value)) {
      setErrorEmail('Invalid email address');
    } else {
      setErrorEmail('');
    }
  };

  const debouncedSubmit = useCallback(
    debounce(() => {
      const userId = localStorage.getItem(STORAGE_USER_ID_KEY);
      const tempFile: File | null = (() => {
        const lastUploadedFile =
          fileUploadedRef.current && fileUploadedRef.current.length > 0
            ? fileUploadedRef.current[fileUploadedRef.current.length - 1].file
            : undefined;
        return lastUploadedFile ?? null;
      })();
      const tempImageFile: File | null =
        imagefileSelected !== undefined ? imagefileSelected : null;
      if (finalPayload && userId !== finalPayload.id) {
        updateEmployeeByAdmin(tempImageFile, tempFile, finalPayload);
      } else if (finalPayload) {
        updateEmployeeByUser(tempImageFile, tempFile, finalPayload);
      }
    }, 500), // 500ms debounce
    [finalPayload],
  );

  const previewTheSelectedFile = () => {
    const disciplineItem =
      employeeData?.employeeCredentials?.credentialFileUrl ?? undefined;
    const previewUrl = disciplineItem ?? '';
    if (!previewUrl && !clickedFile) {
      return null;
    }
    const fileName = employeeData?.employeeCredentials.credentialFileUrl ?? '';
    const fileBasedOnIndex = fileSelected?.[clickedIndex.current].file?.name;
    return (
      <FilePreviewDialog
        url={previewUrl}
        fileName={
          fileName?.startsWith('blob:http')
            ? clickedFile?.file.name
            : 'credentials/' + fileBasedOnIndex
        }
        onClose={() => {
          if (employeeData?.employeeCredentials?.credentialFileUrl) {
            employeeData.employeeCredentials.credentialFileUrl = null;
          }

          setShowPreviewModel(false);
        }}
      />
    );
  };

  const giveMeBackground = (
    index: number,
    size: number,
    currentStartDate: dayjs.Dayjs | undefined,
    nextStartDate: dayjs.Dayjs | undefined,
  ) => {
    if (index === 0 && size === 1) {
      return 'p-sm greenBackground borderRadius10';
    } else if (
      currentStartDate !== undefined &&
      nextStartDate !== undefined &&
      dayjs().isBetween(currentStartDate, nextStartDate)
    ) {
      return 'p-sm greenBackground borderRadius10';
    } else if (
      nextStartDate !== undefined &&
      dayjs().isSame(nextStartDate.subtract(1, 'day'))
    ) {
      return 'p-sm greenBackground borderRadius10';
    } else if (
      currentStartDate !== undefined &&
      dayjs().isSame(currentStartDate)
    ) {
      return 'p-sm greenBackground borderRadius10';
    } else if (
      currentStartDate !== undefined &&
      dayjs().isBefore(currentStartDate)
    ) {
      return 'p-sm beTransparent borderRadius10';
    } else if (
      nextStartDate !== undefined &&
      dayjs().isAfter(nextStartDate.subtract(1, 'day'))
    ) {
      return 'p-sm gray4 borderRadius10';
    } else if (
      currentStartDate !== undefined &&
      nextStartDate === undefined &&
      (dayjs().isAfter(currentStartDate) || dayjs().isSame(currentStartDate))
    ) {
      return 'p-sm greenBackground borderRadius10';
    }

    return 'p-sm grey3 borderRadius10';
  };

  const giveMeBorder = (
    index: number,
    size: number,
    currentStartDate: dayjs.Dayjs | undefined,
    nextStartDate: dayjs.Dayjs | undefined,
  ) => {
    if (index === 0 && size === 1) {
      return {
        border: '2px solid var(--thom-green-primary2-bg)',
        paddingTop: '10px',
        paddingBottom: '10px',
      };
    } else if (
      currentStartDate !== undefined &&
      nextStartDate !== undefined &&
      dayjs().isBetween(currentStartDate, nextStartDate)
    ) {
      return {
        border: '2px solid var(--thom-green-primary2-bg)',
        paddingTop: '10px',
        paddingBottom: '10px',
      };
    } else if (
      nextStartDate !== undefined &&
      dayjs().isSame(nextStartDate.subtract(1, 'day'))
    ) {
      return {
        border: '2px solid var(--thom-green-primary2-bg)',
        paddingTop: '10px',
        paddingBottom: '10px',
      };
    } else if (
      currentStartDate !== undefined &&
      dayjs().isSame(currentStartDate)
    ) {
      return {
        border: '2px solid var(--thom-green-primary2-bg)',
        paddingTop: '10px',
        paddingBottom: '10px',
      };
    } else if (
      currentStartDate !== undefined &&
      dayjs().isBefore(currentStartDate)
    ) {
      return {
        border: '2px solid var(--thom-mono-gray6)',
        paddingTop: '10px',
        paddingBottom: '10px',
      };
    } else if (
      nextStartDate !== undefined &&
      dayjs().isAfter(nextStartDate.subtract(1, 'day'))
    ) {
      return {
        border: '2px solid var(--thom-mono-gray6)',
        paddingTop: '10px',
        paddingBottom: '10px',
      };
    } else if (
      currentStartDate !== undefined &&
      nextStartDate === undefined &&
      (dayjs().isAfter(currentStartDate) || dayjs().isSame(currentStartDate))
    ) {
      return {
        border: '2px solid var(--thom-green-primary2-bg)',
        paddingTop: '10px',
        paddingBottom: '10px',
      };
    }
    return {
      border: '2px solid var(--thom-mono-gray6)',
      paddingTop: '10px',
      paddingBottom: '10px',
    };
  };

  return employeeData !== undefined ? (
    <Box component="main">
      <Box component="section">
        {showPreviewModel && previewTheSelectedFile()}
        <Box className="rowContainer">
          <CustomBackArrow
            onClick={() =>
              navigate(
                screenFrom === 'employeeList'
                  ? EMPLOYEES_ROUTE_NAME
                  : PROFILE_ROUTE_NAME,
              )
            }
          />
          <Box component="div" className="ml-md">
            <TitleText label={getEmployeeName()} defaultlabel="Employee" />
          </Box>
        </Box>
        <ModalPopup
          labelId1="Clientpage.Nobtn"
          negativeActionLabel="No"
          labelId2="Clientpage.Yesbtn"
          positiveActionLabel="Yes"
          open={openActivityCheckModal}
          description={
            checkApiCallErrorCode.code === 1125
              ? 'ProfilePage.ActivityCheck'
              : checkApiCallErrorCode.code === 1134
              ? 'ProfilePage.AppointmentCheck'
              : checkApiCallErrorCode.code === 1135
              ? ['ProfilePage.ActivityCheck', 'ProfilePage.AppointmentCheck']
              : ''
          }
          defaultDescription={activityCheckModalMessage}
          onCancel={() => {
            setOpenActivityCheckModal(false);
            setActivityCheckModalMessage('');
          }}
          onClose={() => {
            setOpenActivityCheckModal(false);
            setActivityCheckModalMessage('');
          }}
          onOk={() => {
            toggleLoader(true);
            debouncedSubmit();
          }}
          maxWidth="sm"
        />
        {toastrId && (
          <SnackBarComponent
            open={toastrId !== undefined}
            handleClose={() => {
              setToastrId(undefined);
            }}
            labelId={toastrId}
            defaultMessageId={defaultMessage}
            successOrError={successOrError}
          />
        )}
        <OnBoardingEmployeeModal
          isSuperAdmin={isAdmin}
          modalVisible={
            isAdmin &&
            (!employeeData.signatureRowKey ||
              !employeeData?.reportingTo ||
              !employeeData?.group.id)
          }
          employeeData={employeeData}
          employeeList={employeeList}
          groups={groupsDropdown}
          handleSubmission={handleSubmission}
        />
        {openEmployeeSignature && (
          <EmployeeSignatureModal
            open={openEmployeeSignature}
            details={signatureDetails.current}
            modalType={signatureViewType.current}
            employeeDetails={employeeData}
            onSuccess={handleSuccess}
            signCanChage={!isAdmin}
            onSave={(signature: string, pin: string) => {
              signatureDetails.current.employeeSignature = signature;
              signatureDetails.current.pin = pin;
              if (formikRef.current !== null) {
                formikRef.current.values.signatureValue = signature;
              }
            }}
            handleClose={() => {
              setOpenEmployeeSignature(!openEmployeeSignature);
            }}
          />
        )}

        {openResetModal && (
          <ResetPinModal
            open={openResetModal}
            employeeDetails={employeeData}
            onSuccess={handleSuccess}
            handleClose={() => {
              setOpenResetModal(!openResetModal);
            }}
            handlePin={pinChangeCallback}
          />
        )}
        <Box component="div">
          <Formik
            innerRef={formikRef}
            initialValues={employeeData}
            validateOnBlur={true}
            validateOnChange={false}
            validateOnMount={true}
            enableReinitialize={true}
            validationSchema={validationSchema}
            validate={validateForm}
            onSubmit={(values) => {
              handleSubmission(values);
            }}
          >
            {({
              values,
              handleChange,
              handleBlur,
              setFieldValue,
              errors,
              touched,
              handleSubmit,
            }) => {
              return (
                <Box component="div" onBlur={handleBlur}>
                  <UnsavedChangesWatcher
                    values={values}
                    originalEmployeeData={originalEmployeeData}
                    onUnsavedChangesChange={handleUpdateUnsavedChanges}
                  />
                  <Card className="formCardview">
                    <Grid container rowSpacing={'24px'} columnSpacing={'40px'}>
                      <Grid item xs={2.5}>
                        <Textinput
                          name="firstName"
                          labelid="AddNewReferralDetails.First"
                          defaultlabelid="First Name"
                          Value={values.firstName}
                          inputProps={{ readOnly: true }}
                          handlechange={(text) => {
                            setFieldValue('firstName', nameValidation(text));
                          }}
                          Required
                        />
                        {errors.firstName && touched.firstName && (
                          <MediumTypography
                            className="errorText-md"
                            labelid={errors.firstName}
                            defaultlabel="Field should not be empty"
                          />
                        )}
                      </Grid>
                      <Grid item xs={2.5}>
                        <Textinput
                          name="middleName"
                          labelid="Clientpage.Middle"
                          defaultlabelid="Middle Name"
                          Value={values.middleName}
                          handlechange={(text) => {
                            setFieldValue('middleName', nameValidation(text));
                          }}
                        />
                      </Grid>
                      <Grid item xs={2.5}>
                        <Textinput
                          name="lastName"
                          labelid="AddNewReferralDetails.Last"
                          defaultlabelid="Last Name"
                          Value={values.lastName}
                          inputProps={{ readOnly: true }}
                          handlechange={(text) => {
                            setFieldValue('lastName', nameValidation(text));
                            setFieldValue(
                              'preferredName',
                              getPreferredName(
                                values.firstName,
                                nameValidation(text),
                              ),
                            );
                          }}
                          Required
                        />
                        {errors.lastName && touched.lastName && (
                          <MediumTypography
                            className="errorText-md"
                            labelid={errors.lastName}
                            defaultlabel="Field should not be empty"
                          />
                        )}
                      </Grid>
                      <Grid item xs={1.5}>
                        <Textinput
                          name="nameSuffix"
                          labelid="AddNewReferralDetails.Suffix"
                          defaultlabelid="Suffix"
                          Value={values.nameSuffix}
                          inputProps={{ maxLength: 20 }}
                          handlechange={(text) => {
                            setFieldValue('nameSuffix', nameValidation(text));
                          }}
                        />
                      </Grid>
                      <Grid item xs={4.5}>
                        <Textinput
                          name="preferredName"
                          labelid="preferredName"
                          type="text"
                          defaultlabelid="Preferred Name"
                          inputProps={{ maxLength: 25 }}
                          Value={values.preferredName}
                          handlechange={(text) => {
                            setFieldValue(
                              'preferredName',
                              nameValidation(text).replace(' ', ''),
                            );
                          }}
                          Required
                        />
                        {errors.preferredName && touched.preferredName && (
                          <MediumTypography
                            className="errorText-md"
                            labelid={errors.preferredName}
                            defaultlabel="Field should not be empty"
                          />
                        )}
                      </Grid>
                      <Grid item xs={4.5}>
                        <Textinput
                          name="email"
                          labelid="Contacts.email"
                          defaultlabelid="Email"
                          Value={values.email}
                          type={'email'}
                          inputProps={{ readOnly: true }}
                          handlechange={handleChange('email')}
                          Required
                        />
                        {errors.email && touched.email && (
                          <MediumTypography
                            className="errorText-md"
                            labelid={errors.email}
                            defaultlabel="Field should not be empty"
                          />
                        )}
                      </Grid>
                      <Grid item xs={3}></Grid>

                      <Grid item xs={3}>
                        <Textinput
                          name="phoneNumber1"
                          labelid="phoneNumber1Text"
                          defaultlabelid="Primary Phone No."
                          Value={values.phoneNumber1}
                          handlechange={(phoneNumber) => {
                            setFieldValue(
                              'phoneNumber1',
                              formatPhoneNumber(phoneNumber),
                            );
                          }}
                          Required
                        />
                        {errors.phoneNumber1 && touched.phoneNumber1 && (
                          <MediumTypography
                            className="errorText-md"
                            labelid={errors.phoneNumber1}
                            defaultlabel="Field should not be empty"
                          />
                        )}
                      </Grid>
                      <Grid item xs={1.5}>
                        <Textinput
                          name="ext"
                          labelid="EmployeeScreen.extentionText"
                          defaultlabelid="Ext."
                          inputProps={{ maxLength: 5 }}
                          Value={values.phoneNumberExtension}
                          handlechange={(phoneNumber) => {
                            const newValue = phoneNumber
                              .trimStart()
                              .replace(/\D/g, '');
                            setFieldValue('phoneNumberExtension', newValue);
                          }}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <Textinput
                          name="phoneNumber2"
                          labelid="phoneNumber2Text"
                          defaultlabelid="Secondary Phone No."
                          Value={values.phoneNumber2}
                          handlechange={(phoneNumber) => {
                            setFieldValue(
                              'phoneNumber2',
                              formatPhoneNumber(phoneNumber),
                            );
                          }}
                        />
                      </Grid>
                      <Grid item xs={1.5}>
                        <Textinput
                          name="ext"
                          labelid="EmployeeScreen.extentionText"
                          defaultlabelid="Ext."
                          inputProps={{ maxLength: 5 }}
                          Value={values.phoneNumberExtension2}
                          handlechange={(phoneNumber) => {
                            const newValue = phoneNumber
                              .trimStart()
                              .replace(/\D/g, '');
                            setFieldValue('phoneNumberExtension2', newValue);
                          }}
                        />
                      </Grid>
                      <Grid item xs={4.5}>
                        <SelectComponent
                          name="employeeType"
                          labelid="employeeTypeText"
                          defaultlabelid="Employee Type"
                          names={employeeTypes}
                          value={values.employeeType ?? ''}
                          disabled={!isAdmin && !isSuperSuperAdmin()}
                          handleChange={(value: string) => {
                            if (value !== originalEmployeeData.employeeType) {
                              formikRef.current?.setValues({
                                ...values,
                                employeeType: value,
                                employeeTypeStartDate: null,
                              });
                            } else {
                              formikRef.current?.setValues({
                                ...values,
                                employeeType: value,
                              });
                            }
                          }}
                          Required={true}
                        />
                        {errors.employeeType && touched.employeeType && (
                          <MediumTypography
                            className="errorText-md"
                            labelid={errors.employeeType}
                            defaultlabel="Field should not be empty"
                          />
                        )}
                      </Grid>
                      <Grid item xs={4.5}>
                        <DatePickerComponent
                          labelid={'employeeTypeStartDate'}
                          defaultlabelid={'Employee Type Start Date'}
                          handlechange={(date: Dayjs | null) => {
                            if (date === null) {
                              formikRef.current?.setValues({
                                ...values,
                                employeeTypeStartDate: null,
                              });
                            } else {
                              formikRef.current?.setValues({
                                ...values,
                                employeeTypeStartDate:
                                  dayjs(date).format('MM/DD/YYYY'),
                              });
                            }
                          }}
                          value={
                            values.employeeTypeStartDate
                              ? dayjs(values.employeeTypeStartDate)
                              : null
                          }
                          shouldDisableDate={(date: Dayjs) => date.day() !== 0}
                          required={true}
                          disabledDate={!isAdmin && !isSuperSuperAdmin()}
                        />
                        {errors.employeeTypeStartDate &&
                          touched.employeeTypeStartDate && (
                            <MediumTypography
                              className="errorText-md"
                              labelid={errors.employeeTypeStartDate}
                              defaultlabel="Field should not be empty"
                            />
                          )}
                      </Grid>
                      <Grid item xs={2.25} display={'none'}>
                        <DatePickerComponent
                          labelid="editEmpstartDateText"
                          defaultlabelid="Start Date*"
                          value={dayjs(values.employeeStartDate)}
                          required={true}
                          disableFuture={false}
                          handlechange={(date: Dayjs | null) => {
                            if (date === null) {
                              formikRef.current?.setValues({
                                ...values,
                                employeeStartDate: null,
                                employeeEndDate: null,
                              });
                            } else {
                              formikRef.current?.setValues({
                                ...values,
                                employeeStartDate:
                                  dayjs(date).format('MM/DD/YYYY'),
                                employeeEndDate: null,
                              });
                            }
                          }}
                        />
                        {errors.employeeStartDate &&
                          touched.employeeStartDate && (
                            <MediumTypography
                              className="errorText-md"
                              labelid={errors.employeeStartDate}
                              defaultlabel="Field should not be empty"
                            />
                          )}
                      </Grid>

                      <Grid item xs={2.25} display={'none'}>
                        <DatePickerComponent
                          labelid="endDateText"
                          defaultlabelid="End Date"
                          value={dayjs(values.employeeEndDate)}
                          minDate={dayjs(values.employeeStartDate).add(
                            1,
                            'day',
                          )}
                          handlechange={(date: Dayjs | null) => {
                            if (values.employeeStartDate) {
                              if (date === null) {
                                setFieldValue('employeeEndDate', null);
                              } else {
                                setFieldValue(
                                  'employeeEndDate',
                                  dayjs(date).format('MM/DD/YYYY'),
                                );
                              }
                            }
                          }}
                        />
                        {errors.employeeEndDate && touched.employeeEndDate && (
                          <MediumTypography
                            className="errorText-md"
                            labelid={errors.employeeEndDate}
                            defaultlabel="Field should not be empty"
                          />
                        )}
                      </Grid>
                      <Grid item xs={4.5}>
                        <Textinput
                          name="workingHoursPerWeek"
                          labelid="workingHoursPerWeek"
                          defaultlabelid="Working Hours Per Week"
                          inputProps={{ maxLength: 6 }} // supports "120.75"
                          Value={values.workingHours?.toString()}
                          handlechange={(text) => {
                            const clean = sanitizeDecimalInput(text);
                            if (clean === '') {
                              setFieldValue('workingHours', '');
                              return;
                            }

                            if (!WORKING_HOURS_REGEX.test(clean)) return;

                            if (clean !== originalEmployeeData.workingHours) {
                              formikRef.current?.setValues({
                                ...values,
                                workingHours: clean,
                                workingHoursPerWeekStartDate: null,
                              });
                            } else {
                              formikRef.current?.setValues({
                                ...values,
                                workingHours: clean,
                              });
                            }
                          }}
                          disabled={!isAdmin && !isSuperSuperAdmin()}
                          Required
                        />

                        {errors.workingHours && touched.workingHours && (
                          <MediumTypography
                            className="errorText-md"
                            labelid={errors.workingHours}
                            defaultlabel="Field should not be empty"
                          />
                        )}
                      </Grid>
                      <Grid item xs={4.5}>
                        <DatePickerComponent
                          labelid={'workingHoursPerWeekStartDate'}
                          defaultlabelid={'Working Hours Start Date'}
                          value={
                            values.workingHoursPerWeekStartDate
                              ? dayjs(values.workingHoursPerWeekStartDate)
                              : null
                          }
                          handlechange={(date: Dayjs | null) => {
                            if (date === null) {
                              formikRef.current?.setValues({
                                ...values,
                                workingHoursPerWeekStartDate: null,
                              });
                            } else {
                              formikRef.current?.setValues({
                                ...values,
                                workingHoursPerWeekStartDate:
                                  dayjs(date).format('MM/DD/YYYY'),
                              });
                            }
                          }}
                          shouldDisableDate={(date: Dayjs) => date.day() !== 0}
                          required={true}
                          disabledDate={!isAdmin && !isSuperSuperAdmin()}
                        />
                        {errors.workingHoursPerWeekStartDate &&
                          touched.workingHoursPerWeekStartDate && (
                            <MediumTypography
                              className="errorText-md"
                              labelid={errors.workingHoursPerWeekStartDate}
                              defaultlabel="Field should not be empty"
                            />
                          )}
                      </Grid>
                      <Grid item xs={4.5}>
                        <Textinput
                          name="productivityGoalText"
                          labelid="productivityGoalText"
                          defaultlabelid="Productivity Goal(%)"
                          inputProps={{ maxLength: 6 }}
                          Value={values.productivityGoal.toString()}
                          handlechange={(text) => {
                            const formatedString = text
                              .replace(/[^0-9.]/g, '') // remove everything except digits and dot
                              .replace(/^(\d*\.\d{0,2}).*$/, '$1'); // keep only up to 2 decimals

                            if (
                              formatedString !==
                              originalEmployeeData.productivityGoal.toString()
                            ) {
                              formikRef.current?.setValues({
                                ...values,
                                productivityGoalStartDate: null,
                                productivityGoal: formatedString,
                              });
                            } else {
                              formikRef.current?.setValues({
                                ...values,
                                productivityGoal: formatedString,
                              });
                            }
                          }}
                          onblur={() => {
                            if (values.productivityGoal) {
                              setFieldValue(
                                'productivityGoal',
                                parseFloat(values.productivityGoal).toFixed(2),
                              );
                            }
                          }}
                          disabled={!isAdmin && !isSuperSuperAdmin()}
                        />
                        {errors.productivityGoal &&
                          touched.productivityGoal && (
                            <MediumTypography
                              className="errorText-md"
                              labelid={errors.productivityGoal}
                              defaultlabel="Field should not be empty"
                            />
                          )}
                      </Grid>
                      <Grid item xs={4.5}>
                        <DatePickerComponent
                          labelid={'productivityGoalStartDate'}
                          defaultlabelid={'Productivity Start Date'}
                          value={
                            values.productivityGoalStartDate
                              ? dayjs(values.productivityGoalStartDate)
                              : null
                          }
                          handlechange={(date: Dayjs | null) => {
                            if (date === null) {
                              formikRef.current?.setValues({
                                ...values,
                                productivityGoalStartDate: null,
                              });
                            } else {
                              formikRef.current?.setValues({
                                ...values,
                                productivityGoalStartDate:
                                  dayjs(date).format('MM/DD/YYYY'),
                              });
                            }
                          }}
                          shouldDisableDate={(date: Dayjs) => date.day() !== 0}
                          required={true}
                          disabledDate={!isAdmin && !isSuperSuperAdmin()}
                        />
                        {errors.productivityGoalStartDate &&
                          touched.productivityGoalStartDate && (
                            <MediumTypography
                              className="errorText-md"
                              labelid={errors.productivityGoalStartDate}
                              defaultlabel="Field should not be empty"
                            />
                          )}
                      </Grid>

                      {values.employeeType !== 'Salaried Exempt' && (
                        <Grid item xs={4.5}>
                          <CheckBoxComponent
                            labelid="lunchWaiverText"
                            defaultlabelid="Lunch Waiver"
                            ischecked={values.lunchWaiverRequired}
                            CheckHandleChange={(
                              event: React.ChangeEvent<HTMLInputElement>,
                            ) => {
                              setFieldValue(
                                'lunchWaiverRequired',
                                event.target.checked,
                              );
                            }}
                            disabled={!isAdmin && !isSuperSuperAdmin()}
                          />
                        </Grid>
                      )}
                      {values.employeeType !== 'Salaried Exempt' && (
                        <Grid item xs={4.5}>
                          <DatePickerComponent
                            labelid={'lunchWaiverStartDateText'}
                            defaultlabelid={'Lunch Waiver Start Date'}
                            value={
                              values.lunchWaiverStartDate
                                ? dayjs(values.lunchWaiverStartDate)
                                : null
                            }
                            handlechange={(date: Dayjs | null) => {
                              if (date === null) {
                                formikRef.current?.setValues({
                                  ...values,
                                  lunchWaiverStartDate: null,
                                });
                              } else {
                                formikRef.current?.setValues({
                                  ...values,
                                  lunchWaiverStartDate:
                                    dayjs(date).format('MM/DD/YYYY'),
                                });
                              }
                            }}
                            shouldDisableDate={(date: Dayjs) =>
                              date.day() !== 0
                            }
                            required={values.employeeType !== 'Salaried Exempt'}
                            disabledDate={!isAdmin && !isSuperSuperAdmin()}
                          />

                          {errors.lunchWaiverStartDate &&
                            touched.lunchWaiverStartDate && (
                              <MediumTypography
                                className="errorText-md"
                                labelid={errors.lunchWaiverStartDate}
                                defaultlabel="Lunch Waiver Start Date cannot be prior to Program Start Date"
                              />
                            )}
                        </Grid>
                      )}

                      <Grid item xs={4.5}>
                        <AutocompleteSearch
                          labelId={'reportingToText'}
                          defaultId="Reporting To"
                          Required
                          optionHintId={'noemployeeDropdownTextId'}
                          sxProps={{
                            [`& .${autocompleteClasses.popupIndicator}`]: {
                              transform: 'none',
                            },
                          }}
                          data={employeeList}
                          selectedValue={values.reportingTo as OptionType}
                          onSelectItem={(value: OptionType | null) => {
                            if (value) {
                              setFieldValue('reportingTo', value);
                            } else {
                              setFieldValue('reportingTo', '');
                            }
                          }}
                          disabled={
                            !isAdmin &&
                            !isSuperSuperAdmin() &&
                            !isPointingToUAT()
                          }
                          disableLabel={true}
                        />
                        {errors.reportingTo && touched.reportingTo && (
                          <MediumTypography
                            className="errorText-md"
                            labelid={errors.reportingTo}
                            defaultlabel="Field should not be empty"
                          />
                        )}
                      </Grid>
                      <Grid item xs={4.5} className="multisearchHgt">
                        <MultipleAutocompleteSearch
                          labelId="employeeRoleText"
                          defaultId="Employee Role"
                          data={employeeRoles}
                          type="string"
                          required
                          onSelectItem={(value: OptionType[] | null) => {
                            if (value) {
                              const selectedContactIds = value.map(
                                (emp) => emp.id,
                              );
                              setFieldValue(
                                'employeeRole',
                                selectedContactIds.toString(),
                              );
                            }
                          }}
                          disableLabel={true}
                          optionHintId={'No Employee Role found'}
                          sxProps={{
                            [`& .${autocompleteClasses.popupIndicator}`]: {
                              transform: 'none',
                              marginTop: '2px',
                            },
                          }}
                          value={values.employeeRole
                            .split(',') // Split the string by comma
                            .map((emp) => ({
                              id: emp,
                              label:
                                employeeRoles.find(
                                  (empRole) => empRole.id === emp,
                                )?.label ?? '', // Set label to empty string if not found
                            }))
                            .filter(
                              (
                                option,
                              ): option is { id: string; label: string } =>
                                option.label !== '', // Filter out options with empty labels
                            )}
                          disabled={
                            !isAdmin &&
                            !isSuperSuperAdmin() &&
                            !isPointingToUAT()
                          }
                        />
                        {errors.employeeRole && touched.employeeRole && (
                          <MediumTypography
                            className="errorText-md"
                            labelid={errors.employeeRole}
                            defaultlabel="Field should not be empty"
                          />
                        )}
                      </Grid>
                      <Grid item xs={4.5} className="multisearchHgt">
                        <AutocompleteSearch
                          labelId={'selectGroupText'}
                          defaultId="Select Group"
                          optionHintId={'noOptionFound'}
                          sxProps={{
                            [`& .${autocompleteClasses.popupIndicator}`]: {
                              transform: 'none',
                            },
                            backgroundColor: 'white',
                          }}
                          data={groupsDropdown}
                          selectedValue={{
                            id: values.group.id || '',
                            label: values.group.groupName || '',
                          }}
                          onSelectItem={(value: OptionType | null) => {
                            if (value) {
                              setFieldValue('group', {
                                id: value.id,
                                groupName: value.label,
                              });
                            } else {
                              setFieldValue('group', { id: '', groupName: '' });
                            }
                          }}
                          disableLabel={true}
                          disabled={
                            !isAdmin &&
                            !isSuperSuperAdmin() &&
                            !isPointingToUAT()
                          }
                          Required
                        />
                        {errors.group && touched.group && (
                          <MediumTypography
                            className="errorText-md"
                            labelid={errors.group.id}
                            defaultlabel="Field should not be empty"
                          />
                        )}
                      </Grid>
                      <Grid item xs={4.5} lg={4.5}>
                        <Textinput
                          labelid="npiNumberText"
                          defaultlabelid="NPI Number"
                          inputProps={{
                            maxLength: 10,
                          }}
                          Required={values.disciplineType !== 'NA'}
                          Value={values.npi}
                          handlechange={(value: string) => {
                            setFieldValue('npi', value);
                          }}
                          disabled={!isAdmin && !isSuperSuperAdmin()}
                        />

                        {errors.npi && touched.npi && (
                          <MediumTypography
                            className="errorText-md"
                            labelid={errors.npi}
                            defaultlabel="NPI Number is required"
                          />
                        )}
                      </Grid>
                      <Grid item xs={4.5}>
                        <DropdownComponent
                          name="staffType"
                          labelid="staffTypeText"
                          defaultlabelid="Tier Type"
                          names={staffTypes}
                          value={
                            values.programs.find(
                              (item) =>
                                item.programId === localSelectedProgramId,
                            )?.staffType || ''
                          }
                          handleChange={() => {}}
                          Required={true}
                          disabled
                        />
                      </Grid>
                      <Grid item lg={12} xs={12}>
                        <Box className="flex__">
                          {employeeData.signaturePartitionKey === '' ||
                          (employeeData.signaturePartitionKey === null &&
                            signatureDetails.current.employeeSignature ===
                              '') ? (
                            <Box>
                              <ButtonComponent
                                className="btn-primary btn-cancel signature_add_Box"
                                labelId="Insurance.Addsignature"
                                defaultLabelId="Add Signature"
                                variantType="outlined"
                                onClick={() => {
                                  setOpenEmployeeSignature(
                                    !openEmployeeSignature,
                                  );
                                  signatureViewType.current = 'add';
                                }}
                              />
                              {errors.signatureValue &&
                                touched.signatureValue && (
                                  <MediumTypography
                                    className="errorText-md mt-lg"
                                    labelid={errors.signatureValue}
                                    defaultlabel="Signature is required"
                                  />
                                )}
                            </Box>
                          ) : (
                            <ButtonComponent
                              className="btn-primary btn-cancel signature_view_Box"
                              labelId="Insurance.Viewsignature"
                              defaultLabelId="View/update signature"
                              variantType="outlined"
                              LeftIcon={<Editsignature />}
                              onClick={() => {
                                if (employeeData.signaturePartitionKey) {
                                  fetchSiganture();
                                } else {
                                  setOpenEmployeeSignature(
                                    !openEmployeeSignature,
                                  );
                                }
                                signatureViewType.current = 'view';
                              }}
                            />
                          )}

                          {employeeData.signaturePartitionKey && !isAdmin && (
                            <Box
                              className="ml-sm "
                              sx={{ alignSelf: 'center' }}
                            >
                              <Box className="flex__ alignItemCenter">
                                <ButtonComponent
                                  className="btn-add-code"
                                  variantType="contained"
                                  type="submit"
                                  labelId="employeeSig.changeSignatureText"
                                  defaultLabelId="Change Signature"
                                  onClick={() => {
                                    signatureViewType.current = 'change';
                                    setOpenEmployeeSignature(
                                      !openEmployeeSignature,
                                    );
                                  }}
                                />
                              </Box>
                            </Box>
                          )}
                          {employeeData.signaturePartitionKey && !isAdmin && (
                            <Box
                              className="ml-sm "
                              sx={{ alignSelf: 'center' }}
                            >
                              <Box className="flex__ alignItemCenter">
                                <ButtonComponent
                                  className="btn-add-code"
                                  variantType="contained"
                                  type="submit"
                                  labelId="employeeSig.forgotPinText"
                                  defaultLabelId="Reset/Forgot PIN"
                                  onClick={() => {
                                    callForgotPinApi();
                                  }}
                                />
                              </Box>
                            </Box>
                          )}
                        </Box>
                      </Grid>

                      <Grid item lg={10} className="mt-sm">
                        <MediumTypography
                          textColor="#2A4241"
                          fontweight={600}
                          labelid="employeeCredentialsText"
                          defaultlabel="Employee Discipline"
                        />
                      </Grid>
                      <Grid item xs={14} lg={14}>
                        <Box>
                          {values.disciplineHistoryList &&
                            [...Array(values.disciplineHistoryList.length)].map(
                              (emb, index) => {
                                return (
                                  <Box
                                    key={
                                      values.disciplineHistoryList?.[index]
                                        ?.fId ?? index
                                    }
                                  >
                                    <Box
                                      className={giveMeBackground(
                                        index,
                                        values.disciplineHistoryList?.length ??
                                          0,
                                        index >= 0 &&
                                          values.disciplineHistoryList?.[index]
                                            ?.startDate
                                          ? dayjs(
                                              values.disciplineHistoryList[
                                                index
                                              ].startDate,
                                            )
                                          : undefined,
                                        values.disciplineHistoryList &&
                                          index + 1 <
                                            values.disciplineHistoryList
                                              ?.length &&
                                          values.disciplineHistoryList?.[
                                            index + 1
                                          ]?.startDate
                                          ? dayjs(
                                              values.disciplineHistoryList[
                                                index + 1
                                              ].startDate,
                                            )
                                          : undefined,
                                      )}
                                      sx={giveMeBorder(
                                        index,
                                        values.disciplineHistoryList?.length ??
                                          0,
                                        index >= 0 &&
                                          values.disciplineHistoryList?.[index]
                                            ?.startDate
                                          ? dayjs(
                                              values.disciplineHistoryList[
                                                index
                                              ].startDate,
                                            )
                                          : undefined,
                                        values.disciplineHistoryList &&
                                          index + 1 <
                                            values.disciplineHistoryList
                                              ?.length &&
                                          values.disciplineHistoryList?.[
                                            index + 1
                                          ]?.startDate
                                          ? dayjs(
                                              values.disciplineHistoryList[
                                                index + 1
                                              ].startDate,
                                            )
                                          : undefined,
                                      )}
                                    >
                                      <Grid
                                        container
                                        rowSpacing={'24px'}
                                        columnSpacing={'40px'}
                                        paddingTop={'10px'}
                                        paddingBottom={'10px'}
                                      >
                                        <Grid item xs={4.5} lg={4.5}>
                                          <DropdownComponent
                                            names={disciplineList}
                                            labelid="EmployeeScreen.DisciplineText"
                                            disabled={
                                              (!isAdmin &&
                                                !isSuperSuperAdmin()) ||
                                              (Array.isArray(
                                                values.disciplineHistoryList,
                                              ) &&
                                                values.disciplineHistoryList
                                                  .length -
                                                  1 >
                                                  index)
                                            }
                                            defaultlabelid="Discipline"
                                            value={
                                              values.disciplineHistoryList?.[
                                                index
                                              ]?.disciplineType ?? undefined
                                            }
                                            handleChange={(e) => {
                                              if (
                                                originalEmployeeData.disciplineHistoryList &&
                                                index <
                                                  originalEmployeeData
                                                    .disciplineHistoryList
                                                    ?.length &&
                                                e !==
                                                  originalEmployeeData
                                                    .disciplineHistoryList?.[
                                                    index
                                                  ]?.disciplineType
                                              ) {
                                                formikRef.current?.setFieldValue(
                                                  `disciplineHistoryList.${index}.isChanged`,
                                                  true,
                                                );
                                              }
                                              formikRef.current?.setFieldValue(
                                                `disciplineHistoryList.${index}.disciplineType`,
                                                e,
                                              );
                                            }}
                                            disableClearable={true}
                                            Required
                                          />
                                          {Array.isArray(
                                            errors.disciplineHistoryList,
                                          ) &&
                                            errors.disciplineHistoryList
                                              .length > index &&
                                            (
                                              errors.disciplineHistoryList[
                                                index
                                              ] as
                                                | FormikErrors<EmployeeDisciplineHistory>
                                                | undefined
                                            )?.disciplineType &&
                                            Array.isArray(
                                              touched.disciplineHistoryList,
                                            ) &&
                                            touched.disciplineHistoryList
                                              .length > index &&
                                            (
                                              touched.disciplineHistoryList[
                                                index
                                              ] as
                                                | {
                                                    disciplineType?: unknown;
                                                  }
                                                | undefined
                                            )?.disciplineType !== undefined && (
                                              <MediumTypography
                                                className="errorText-md"
                                                labelid={
                                                  (
                                                    errors
                                                      .disciplineHistoryList[
                                                      index
                                                    ] as
                                                      | FormikErrors<EmployeeDisciplineHistory>
                                                      | undefined
                                                  )?.disciplineType as string
                                                }
                                                defaultlabel="Discipline Type is required"
                                              />
                                            )}
                                        </Grid>
                                        <Grid item xs={4.5} lg={4.5}>
                                          <DatePickerComponent
                                            labelid="EmployeeScreen.DisStartDate"
                                            className="bg__white"
                                            defaultlabelid="Start Date"
                                            minDate={
                                              index > 0 &&
                                              values.disciplineHistoryList?.[
                                                index - 1
                                              ]?.startDate
                                                ? dayjs(
                                                    values
                                                      .disciplineHistoryList[
                                                      index - 1
                                                    ].startDate,
                                                  ).add(1, 'day')
                                                : undefined
                                            }
                                            value={
                                              values.disciplineHistoryList
                                                ? dayjs(
                                                    values
                                                      .disciplineHistoryList[
                                                      index
                                                    ].startDate,
                                                  )
                                                : null
                                            }
                                            handlechange={(
                                              date: Dayjs | null,
                                            ) => {
                                              if (
                                                originalEmployeeData.disciplineHistoryList &&
                                                index <
                                                  originalEmployeeData
                                                    .disciplineHistoryList
                                                    ?.length &&
                                                date !==
                                                  originalEmployeeData
                                                    .disciplineHistoryList?.[
                                                    index
                                                  ]?.startDate
                                              ) {
                                                formikRef.current?.setFieldValue(
                                                  `disciplineHistoryList.${index}.isChanged`,
                                                  true,
                                                );
                                              }
                                              if (date === null) {
                                                formikRef.current?.setFieldValue(
                                                  `disciplineHistoryList.${index}.startDate`,
                                                  null,
                                                );
                                              } else {
                                                formikRef.current?.setFieldValue(
                                                  `disciplineHistoryList.${index}.startDate`,
                                                  dayjs(date).format(
                                                    'MM/DD/YYYY',
                                                  ),
                                                );
                                              }
                                            }}
                                            disabledDate={
                                              (!isAdmin &&
                                                !isSuperSuperAdmin()) ||
                                              index === 0 ||
                                              (Array.isArray(
                                                values.disciplineHistoryList,
                                              ) &&
                                                values.disciplineHistoryList
                                                  .length -
                                                  1 >
                                                  index)
                                            }
                                          />
                                          {errors.disciplineHistoryList &&
                                            errors.disciplineHistoryList
                                              .length > 0 &&
                                            errors.disciplineHistoryList
                                              .length > index &&
                                            (
                                              errors.disciplineHistoryList[
                                                index
                                              ] as FormikErrors<EmployeeDisciplineHistory>
                                            )?.startDate &&
                                            touched.disciplineHistoryList &&
                                            Array.isArray(
                                              touched.disciplineHistoryList,
                                            ) &&
                                            touched.disciplineHistoryList
                                              .length > 0 &&
                                            touched.disciplineHistoryList[index]
                                              ?.startDate && (
                                              <MediumTypography
                                                className="errorText-md"
                                                labelid={
                                                  (
                                                    errors
                                                      .disciplineHistoryList[
                                                      index
                                                    ] as FormikErrors<EmployeeDisciplineHistory>
                                                  )?.startDate
                                                }
                                                defaultlabel="Field should not be empty"
                                              />
                                            )}
                                        </Grid>
                                        <Grid item xs={4.5} lg={4.5}>
                                          <Textinput
                                            name="credentialLicenceNum"
                                            className="bg__white"
                                            labelid="employee.credentialLicenceNum"
                                            defaultlabelid="License Number"
                                            Value={
                                              values.disciplineHistoryList
                                                ? values.disciplineHistoryList[
                                                    index
                                                  ].credentialLicenseNumber
                                                : ''
                                            }
                                            inputProps={{
                                              maxLength: 20,
                                            }}
                                            handlechange={(text) => {
                                              const validatedValue =
                                                licenseNumValidation(text);
                                              if (
                                                validatedValue !== undefined
                                              ) {
                                                if (
                                                  originalEmployeeData.disciplineHistoryList &&
                                                  index <
                                                    originalEmployeeData
                                                      .disciplineHistoryList
                                                      ?.length &&
                                                  validatedValue !==
                                                    originalEmployeeData
                                                      .disciplineHistoryList?.[
                                                      index
                                                    ]?.credentialLicenseNumber
                                                ) {
                                                  formikRef.current?.setFieldValue(
                                                    `disciplineHistoryList.${index}.isChanged`,
                                                    true,
                                                  );
                                                }
                                                formikRef.current?.setFieldValue(
                                                  `disciplineHistoryList.${index}.credentialLicenseNumber`,
                                                  validatedValue,
                                                );
                                              }
                                            }}
                                            disabled={
                                              (!isAdmin &&
                                                !isSuperSuperAdmin()) ||
                                              (Array.isArray(
                                                values.disciplineHistoryList,
                                              ) &&
                                                values.disciplineHistoryList
                                                  .length -
                                                  1 >
                                                  index)
                                            }
                                          />
                                        </Grid>

                                        <Grid item xs={4.5} lg={4.5}>
                                          <DatePickerComponent
                                            labelid="expDate"
                                            className="bg__white"
                                            defaultlabelid="License Expiration Date"
                                            value={
                                              values.disciplineHistoryList
                                                ? dayjs(
                                                    values
                                                      .disciplineHistoryList[
                                                      index
                                                    ].credentialExpirationDate,
                                                  )
                                                : null
                                            }
                                            handlechange={(
                                              date: Dayjs | null,
                                            ) => {
                                              if (
                                                originalEmployeeData.disciplineHistoryList &&
                                                index <
                                                  originalEmployeeData
                                                    .disciplineHistoryList
                                                    ?.length &&
                                                date !==
                                                  originalEmployeeData
                                                    .disciplineHistoryList?.[
                                                    index
                                                  ]?.credentialExpirationDate
                                              ) {
                                                formikRef.current?.setFieldValue(
                                                  `disciplineHistoryList.${index}.isChanged`,
                                                  true,
                                                );
                                              }
                                              if (date === null) {
                                                formikRef.current?.setFieldValue(
                                                  `disciplineHistoryList.${index}.credentialExpirationDate`,
                                                  null,
                                                );
                                              } else {
                                                formikRef.current?.setFieldValue(
                                                  `disciplineHistoryList.${index}.credentialExpirationDate`,
                                                  dayjs(date).format(
                                                    'MM/DD/YYYY',
                                                  ),
                                                );
                                              }
                                            }}
                                            disabledDate={
                                              (!isAdmin &&
                                                !isSuperSuperAdmin()) ||
                                              (Array.isArray(
                                                values.disciplineHistoryList,
                                              ) &&
                                                values.disciplineHistoryList
                                                  .length -
                                                  1 >
                                                  index)
                                            }
                                          />
                                        </Grid>

                                        <Grid item xs={4.5} lg={4.5}>
                                          <TextField
                                            className="fileUploadInput bg__white"
                                            disabled
                                            size="small"
                                            InputProps={{
                                              startAdornment: (
                                                <Grid
                                                  item
                                                  sx={{
                                                    display: 'flex',
                                                    maxWidth: 'auto',
                                                    position: 'absolute',
                                                  }}
                                                >
                                                  {!!fileSelected?.[index]
                                                    ?.file && (
                                                    <Grid
                                                      item
                                                      width={'100%'}
                                                      className="fileuploadwidth"
                                                    >
                                                      <Tooltip
                                                        title={
                                                          fileSelected?.[index]
                                                            ?.file?.name ?? ''
                                                        }
                                                      >
                                                        <Chip
                                                          label={
                                                            fileSelected?.[
                                                              index
                                                            ]?.file?.name ?? ''
                                                          }
                                                          clickable
                                                          sx={{
                                                            borderRadius: '4px',
                                                            overflow: 'hidden',
                                                            textOverflow:
                                                              'ellipsis',
                                                            whiteSpace:
                                                              'nowrap',
                                                            height: '26px',
                                                            display: 'block',
                                                            position:
                                                              'relative',
                                                            textDecorationLine:
                                                              'underline',
                                                          }}
                                                          onClick={() => {
                                                            if (
                                                              PREVIEW_DOCUMENT_EXTENSIONS.includes(
                                                                extractFileExtension(
                                                                  fileSelected?.[
                                                                    index
                                                                  ]?.file
                                                                    ?.name ??
                                                                    '',
                                                                ).toLowerCase(),
                                                              )
                                                            ) {
                                                              handlePreviewClick(
                                                                index,
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      </Tooltip>
                                                    </Grid>
                                                  )}
                                                  <Grid
                                                    item
                                                    display={
                                                      (!isAdmin &&
                                                        !isSuperSuperAdmin()) ||
                                                      (Array.isArray(
                                                        values.disciplineHistoryList,
                                                      ) &&
                                                        values
                                                          .disciplineHistoryList
                                                          .length -
                                                          1 >
                                                          index)
                                                        ? 'none'
                                                        : 'flex'
                                                    }
                                                  >
                                                    {fileSelected?.[index]
                                                      ?.file !== undefined && (
                                                      <Box
                                                        style={{
                                                          position: 'relative',
                                                          cursor: 'pointer',
                                                          top: '10%',
                                                        }}
                                                        onClick={() => {
                                                          formikRef.current?.setFieldValue(
                                                            `disciplineHistoryList.${index}.isChanged`,
                                                            true,
                                                          );
                                                          if (
                                                            isFileDeletedBeforeUploadRef.current ===
                                                            true
                                                          ) {
                                                            formikRef.current?.setFieldValue(
                                                              `disciplineHistoryList.${index}.credentialFileUrl`,
                                                              null,
                                                            );
                                                          }
                                                          onChipDelete(index);
                                                        }}
                                                      >
                                                        <CloseIcon />
                                                      </Box>
                                                    )}
                                                  </Grid>
                                                </Grid>
                                              ),
                                              endAdornment: (
                                                <InputAdornment
                                                  className="sdfsdfsdfsdfsdf"
                                                  position="end"
                                                  sx={{
                                                    marginLeft: '0px',
                                                    position: 'relative',
                                                    left: '1%',
                                                    display: 'flex',
                                                  }}
                                                >
                                                  <input
                                                    ref={(el) =>
                                                      (inputFileRef.current[
                                                        index
                                                      ] = el)
                                                    }
                                                    type="file"
                                                    accept=".pdf"
                                                    style={{
                                                      display: 'none',
                                                      height: '36px',
                                                    }}
                                                    onChange={(e) => {
                                                      handleFileChange(
                                                        e,
                                                        index,
                                                      );
                                                      const selectedFile =
                                                        e.target.files !==
                                                          null &&
                                                        e.target.files.length >
                                                          0
                                                          ? e.target.files[0]
                                                          : null;
                                                      if (
                                                        selectedFile !== null
                                                      ) {
                                                        if (
                                                          fileUploadedRef.current &&
                                                          fileSelected &&
                                                          selectedFile.type ===
                                                            'application/pdf' &&
                                                          selectedFile.size <=
                                                            5242880 &&
                                                          selectedFile.size !==
                                                            0
                                                        ) {
                                                          formikRef.current?.setFieldValue(
                                                            `disciplineHistoryList.${index}.isChanged`,
                                                            true,
                                                          );
                                                        }
                                                      }
                                                    }}
                                                  />
                                                  <UploadButton
                                                    title="uploaddocument"
                                                    paddingBottom="0px"
                                                    paddingTop="0px"
                                                    disable={
                                                      (!isAdmin &&
                                                        !isSuperSuperAdmin()) ||
                                                      (Array.isArray(
                                                        values.disciplineHistoryList,
                                                      ) &&
                                                        values
                                                          .disciplineHistoryList
                                                          .length -
                                                          1 >
                                                          index)
                                                    }
                                                    Icon={<DocIcon />}
                                                    onClick={() =>
                                                      browseFiles(index)
                                                    }
                                                  />
                                                </InputAdornment>
                                              ),
                                            }}
                                          />
                                        </Grid>
                                        {employeeData.disciplineHistoryList &&
                                          employeeData.disciplineHistoryList
                                            .length > 0 &&
                                          employeeData.disciplineHistoryList[
                                            index
                                          ].isDeleted && (
                                            <Grid
                                              item
                                              xs={4.5}
                                              lg={4.5}
                                              display="flex"
                                              alignItems="center"
                                            >
                                              <ButtonComponent
                                                className="btn-add-code"
                                                variantType="contained"
                                                LeftIcon={<TrashIcon />}
                                                sxProps={{
                                                  color:
                                                    'var(--thom-brown) !important',
                                                  textDecoration:
                                                    'none !important',
                                                }}
                                                type="submit"
                                                labelId="Employee.DisciplineDelete"
                                                defaultLabelId="Delete"
                                                onClick={() => {
                                                  setAddDesciplineEnable(true);
                                                  if (
                                                    employeeData.disciplineHistoryList &&
                                                    employeeData
                                                      .disciplineHistoryList
                                                      .length > 0
                                                  ) {
                                                    const next = [
                                                      ...(values.disciplineHistoryList ??
                                                        []),
                                                    ];
                                                    next.pop();
                                                    employeeData.disciplineHistoryList.pop();
                                                    setEmployeeData({
                                                      ...employeeData,
                                                    });
                                                    setFieldValue(
                                                      'disciplineHistoryList',
                                                      next,
                                                    );
                                                  }
                                                }}
                                              />
                                            </Grid>
                                          )}
                                      </Grid>
                                    </Box>
                                    <Grid
                                      item
                                      xs={4.5}
                                      lg={4.5}
                                      margin="10px"
                                    ></Grid>
                                  </Box>
                                );
                              },
                            )}
                          {(isAdmin || isSuperSuperAdmin()) &&
                            addDesciplineEnable && (
                              <ButtonComponent
                                className="btn-add-code mb-md"
                                variantType="contained"
                                type="submit"
                                labelId="IFSP.AddNewSection"
                                defaultLabelId="+ Add New"
                                onClick={() => {
                                  setAddDesciplineEnable(false);
                                  if (employeeData.disciplineHistoryList) {
                                    const employeeDisciplineHistory: EmployeeDisciplineHistory =
                                      {
                                        fId: uuidv4(),
                                        id: null,
                                        disciplineType: null,
                                        credentialLicenseNumber: null,
                                        credentialExpirationDate: null,
                                        credentialFileUrl: null,
                                        startDate: null,
                                        isChanged: true,
                                        isDeleted: true,
                                      };
                                    const next = [
                                      ...(values.disciplineHistoryList ?? []),
                                      employeeDisciplineHistory,
                                    ];
                                    employeeData.disciplineHistoryList.push(
                                      employeeDisciplineHistory,
                                    );
                                    setEmployeeData({ ...employeeData });
                                    setFieldValue(
                                      'disciplineHistoryList',
                                      next,
                                    );
                                  }
                                }}
                              />
                            )}
                        </Box>
                      </Grid>

                      <Grid item xs={10}>
                        <MediumTypography
                          textColor="#2A4241"
                          fontweight={600}
                          labelid="addProgramsText"
                          defaultlabel="Programs"
                        />
                      </Grid>

                      {[...Array(numOfPrograms)].map((e, i) => (
                        <Grid
                          key={(i + 1).toString()}
                          container
                          rowSpacing={'24px'}
                          columnSpacing={'40px'}
                          className="pt-md"
                        >
                          <Grid item xs={0.1}></Grid>
                          <Grid item xs={0.1}>
                            <CheckBoxComponent
                              name="defaultProgram"
                              labelid=""
                              defaultlabelid=""
                              ischecked={
                                values.programs[i].programId === defaultProgram
                              }
                              CheckHandleChange={() => {
                                handleCheckboxChange(values, i);
                              }}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <SelectComponent
                              name="selectProgram"
                              labelid="selectProgramText"
                              defaultlabelid="Select Program"
                              SelectLabel={values.programs[i].programName}
                              value={values.programs[i].programName}
                              names={programList}
                              disabled={!values.programs[i].editable}
                              handleChange={(value: string) => {
                                handleProgramChange(value, i, values);
                              }}
                            />
                            {errors.programs &&
                              errors.programs.length !== 0 &&
                              errors.programs.length > i &&
                              errors.programs[i] &&
                              (errors.programs[i] as FormikErrors<Program>)
                                .programName &&
                              touched.programs &&
                              touched.programs.length > i &&
                              touched.programs[i].programName && (
                                <MediumTypography
                                  className="errorText-md"
                                  labelid={
                                    (
                                      errors.programs[
                                        i
                                      ] as FormikErrors<Program>
                                    ).programName
                                  }
                                  defaultlabel="Field should not be empty"
                                />
                              )}
                          </Grid>

                          <Grid item xs={2.2}>
                            <DatePickerComponent
                              disabledDate={
                                !isAdmin &&
                                !isSuperSuperAdmin() &&
                                !isPointingToUAT()
                              }
                              labelid="startDateText"
                              defaultlabelid="Start Date"
                              required={true}
                              value={dayjs(values.programs[i].programStartDate)}
                              handlechange={(date: Dayjs | null) => {
                                const updatedPrograms = [...values.programs]; // Create a copy of the programs array
                                if (date === null) {
                                  updatedPrograms[i] = {
                                    ...updatedPrograms[i],
                                    programStartDate: null,
                                    programEndDate: null,
                                  };
                                } else {
                                  updatedPrograms[i] = {
                                    ...updatedPrograms[i],
                                    programStartDate:
                                      dayjs(date).format('MM/DD/YYYY'),
                                    programEndDate: null,
                                  };
                                }

                                formikRef.current?.setValues({
                                  ...values,
                                  programs: updatedPrograms,
                                });
                              }}
                            />
                            {errors.programs &&
                              errors.programs.length !== 0 &&
                              errors.programs.length > i &&
                              errors.programs[i] &&
                              (errors.programs[i] as FormikErrors<Program>)
                                .programStartDate &&
                              touched.programs &&
                              touched.programs.length > i &&
                              touched.programs[i].programStartDate && (
                                <MediumTypography
                                  className="errorText-md"
                                  labelid={(
                                    errors.programs[i] as FormikErrors<Program>
                                  ).programStartDate?.toString()}
                                  defaultlabel="Field should not be empty"
                                />
                              )}
                            <Box className="pt-xs">
                              <Box display="flex" alignItems="center">
                                <CheckBoxComponent
                                  labelid="rehireEligibleText"
                                  defaultlabelid="Rehire"
                                  ischecked={values.isRehireChecked ?? false}
                                  CheckHandleChange={(
                                    event: React.ChangeEvent<HTMLInputElement>,
                                  ) => {
                                    setFieldValue(
                                      'isRehireChecked',
                                      event.target.checked,
                                    );
                                    if (!event.target.checked) {
                                      setFieldValue('rehireMonths', undefined);
                                    }
                                  }}
                                  disabled={
                                    !isAdmin ||
                                    !hasTierRangeAdjustmentEditPermission
                                  }
                                />
                                <ActionToolTip
                                  labelId="rehireEligibleTooltipText"
                                  defaultLabel="You can enter the number of months in the text field, and the Tier Range can be adjusted accordingly in TBB."
                                >
                                  <InfoIcon
                                    style={{
                                      cursor: 'pointer',
                                      flexShrink: 0,
                                      marginLeft: 0,
                                      pointerEvents:
                                        isAdmin &&
                                        hasTierRangeAdjustmentEditPermission
                                          ? 'auto'
                                          : 'none',
                                    }}
                                  />
                                </ActionToolTip>
                              </Box>
                              {values.isRehireChecked && (
                                <Box className="pt-sm">
                                  <Textinput
                                    name="rehireMonths"
                                    labelid="rehireMonthsText"
                                    defaultlabelid="Months"
                                    Value={
                                      values.rehireMonths?.toString() ?? ''
                                    }
                                    type="numeric"
                                    inputProps={{ maxLength: 3 }}
                                    handlechange={(value: string) => {
                                      const clean = value.replace(/\D/g, '');
                                      if (clean === '') {
                                        setFieldValue('rehireMonths', null);
                                        return;
                                      }
                                      const numericValue = parseInt(clean, 10);
                                      if (
                                        numericValue === 0 ||
                                        numericValue > 999
                                      )
                                        return;
                                      setFieldValue(
                                        'rehireMonths',
                                        numericValue,
                                      );
                                    }}
                                    className="bg__white"
                                    disabled={
                                      !isAdmin ||
                                      !hasTierRangeAdjustmentEditPermission
                                    }
                                  />
                                </Box>
                              )}
                            </Box>
                            {values.isRehireChecked && errors.rehireMonths && (
                              <MediumTypography
                                className="errorText-md"
                                textstyle="left"
                                labelid={errors.rehireMonths}
                                defaultlabel="Months field is required."
                              />
                            )}
                          </Grid>

                          <Grid item xs={2.2}>
                            <DatePickerComponent
                              labelid="endDateText"
                              defaultlabelid="End Date"
                              disabledDate={
                                !isAdmin &&
                                !isSuperSuperAdmin() &&
                                !isPointingToUAT()
                              }
                              minDate={
                                values.programs[i].programStartDate
                                  ? dayjs(values.programs[i].programStartDate)
                                  : undefined
                              }
                              disableFuture={true}
                              value={
                                values.programs[i].programEndDate !== null
                                  ? dayjs(values.programs[i].programEndDate)
                                  : null
                              }
                              handlechange={(date: Dayjs | null) => {
                                if (values.programs[i].programStartDate) {
                                  const updatedPrograms = [...values.programs]; // Create a copy of the programs array
                                  if (date === null) {
                                    updatedPrograms[i] = {
                                      ...updatedPrograms[i],
                                      programEndDate: null,
                                    };
                                  } else {
                                    updatedPrograms[i] = {
                                      ...updatedPrograms[i],
                                      programEndDate:
                                        dayjs(date).format('MM/DD/YYYY'),
                                    };
                                  }

                                  formikRef.current?.setValues({
                                    ...values,
                                    programs: updatedPrograms,
                                  });
                                }
                              }}
                            />
                            {errors.programs &&
                              errors.programs.length !== 0 &&
                              errors.programs.length > i &&
                              errors.programs[i] &&
                              (errors.programs[i] as FormikErrors<Program>)
                                .programEndDate &&
                              touched.programs &&
                              touched.programs.length > i &&
                              touched.programs[i].programEndDate && (
                                <MediumTypography
                                  className="errorText-md"
                                  labelid={(
                                    errors.programs[i] as FormikErrors<Program>
                                  ).programEndDate?.toString()}
                                  defaultlabel="Field should not be empty"
                                />
                              )}
                          </Grid>

                          {i !== 0 && values.programs[i].editable && (
                            <Grid
                              item
                              xs={2.5}
                              style={{
                                display: 'flex',
                                marginTop: '16px',
                              }}
                            >
                              <DeleteAlertIcon
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  handleDeleteProgram(values, i);
                                }}
                              />
                            </Grid>
                          )}
                        </Grid>
                      ))}

                      <Grid item xs={9} className="pt-none">
                        {errors.defaultProgram && touched.defaultProgram && (
                          <MediumTypography
                            className="errorText-md"
                            labelid={errors.defaultProgram}
                            defaultlabel="Please select a default program"
                          />
                        )}
                      </Grid>
                      <Grid item xs={9}>
                        <AddressForm
                          address1PlaceholderId="address1Text"
                          address2PlaceholderId="address2Text"
                          zipCodePlaceholderId="Clientpage.Zip"
                          cityPlaceholderId="Clientpage.City"
                          statePlaceholderId="Clientpage.State"
                          headerTitleId="primaryAddressText"
                          value={values.address1}
                          isClient={false}
                          disableForm={false}
                          formRequired={true}
                          formikErrors={errors.address1}
                          formikTouched={touched.address1}
                          handleAddressUpdate={(newAddress) => {
                            formikRef.current?.setValues({
                              ...values,
                              address1: newAddress,
                            });
                          }}
                        />
                      </Grid>
                      <Grid item xs={9} className="pt-sm">
                        <CheckBoxComponent
                          name="secondaryAddressFlag"
                          labelid="secondaryAddressText"
                          defaultlabelid="Secondary Address"
                          ischecked={values.secondaryAddressRequired}
                          CheckHandleChange={(
                            event: React.ChangeEvent<HTMLInputElement>,
                          ) => {
                            setFieldValue(
                              'secondaryAddressRequired',
                              event.target.checked,
                            );
                          }}
                        />
                        {values.secondaryAddressRequired && (
                          <Box sx={{ marginTop: '16px' }}>
                            <AddressForm
                              address1PlaceholderId="address1Text"
                              address2PlaceholderId="address2Text"
                              zipCodePlaceholderId="Clientpage.Zip"
                              cityPlaceholderId="Clientpage.City"
                              statePlaceholderId="Clientpage.State"
                              value={values.address2}
                              isClient={false}
                              disableForm={false}
                              formRequired={true}
                              formikErrors={errors.address2}
                              formikTouched={touched.address2}
                              handleAddressUpdate={(newAddress) => {
                                formikRef.current?.setValues({
                                  ...values,
                                  address2: newAddress,
                                });
                              }}
                            />
                          </Box>
                        )}
                      </Grid>
                      <Grid item xs={10} className="pt-sm">
                        <MediumTypography
                          textColor="#2A4241"
                          fontweight={600}
                          labelid="emergencyContactText"
                          defaultlabel="Emergency contact"
                        />
                      </Grid>

                      <Grid item xs={4.5}>
                        <Textinput
                          name="firstName"
                          labelid="AddNewReferralDetails.First"
                          defaultlabelid="First Name"
                          Value={values.emergencyContact.firstName}
                          inputProps={{ maxLength: 50 }}
                          handlechange={(text) => {
                            setFieldValue(
                              'emergencyContact.firstName',
                              nameValidation(text),
                            );
                          }}
                        />
                        {errors.emergencyContact?.firstName &&
                          touched.emergencyContact?.firstName && (
                            <MediumTypography
                              className="errorText-md"
                              labelid={errors.emergencyContact.firstName}
                              defaultlabel="Field should not be empty"
                            />
                          )}
                      </Grid>
                      <Grid item xs={4.5}>
                        <Textinput
                          name="lastName"
                          labelid="AddNewReferralDetails.Last"
                          defaultlabelid="Last Name"
                          Value={values.emergencyContact.lastName}
                          inputProps={{ maxLength: 50 }}
                          handlechange={(text) => {
                            setFieldValue(
                              'emergencyContact.lastName',
                              nameValidation(text),
                            );
                          }}
                        />
                        {errors.emergencyContact?.lastName &&
                          touched.emergencyContact?.lastName && (
                            <MediumTypography
                              className="errorText-md"
                              labelid={errors.emergencyContact.lastName}
                              defaultlabel="Field should not be empty"
                            />
                          )}
                      </Grid>

                      <Grid item xs={4.5}>
                        <Textinput
                          name="phoneNumber"
                          labelid="Contacts.phone"
                          defaultlabelid="Phone number"
                          Value={values.emergencyContact.phoneNumber}
                          handlechange={(phoneNumber) => {
                            setFieldValue(
                              'emergencyContact.phoneNumber',
                              formatPhoneNumber(phoneNumber),
                            );
                          }}
                        />
                        {errors.emergencyContact?.phoneNumber &&
                          touched.emergencyContact?.phoneNumber && (
                            <MediumTypography
                              className="errorText-md"
                              labelid={errors.emergencyContact.phoneNumber}
                              defaultlabel="Field should not be empty"
                            />
                          )}
                      </Grid>
                      <Grid item xs={4.5}>
                        <Textinput
                          name="email"
                          labelid="Contacts.email"
                          defaultlabelid="Email"
                          type={'email'}
                          Value={values.emergencyContact.email}
                          handlechange={(value: string) => {
                            handleEmailChange(value);
                            setFieldValue('emergencyContact.email', value);
                          }}
                          inputProps={{
                            maxLength: 320,
                          }}
                        />
                        {errorEmail !== '' && (
                          <MediumTypography
                            sxProps={{ color: 'red' }}
                            labelid="parent.emailMessage"
                            defaultlabel="Invalid Email"
                          />
                        )}
                        {errors.emergencyContact?.email &&
                          touched.emergencyContact?.email && (
                            <MediumTypography
                              className="errorText-md"
                              labelid={errors.emergencyContact.email}
                              defaultlabel="Field should not be empty"
                            />
                          )}
                      </Grid>
                      <Grid item xs={9}>
                        <AddressForm
                          address1PlaceholderId="address1Text"
                          address2PlaceholderId="address2Text"
                          zipCodePlaceholderId="Clientpage.Zip"
                          cityPlaceholderId="Clientpage.City"
                          statePlaceholderId="Clientpage.State"
                          value={values.emergencyContact.address}
                          isClient={false}
                          disableForm={false}
                          formRequired={false}
                          formikErrors={errors.emergencyContact?.address}
                          formikTouched={touched.emergencyContact?.address}
                          handleAddressUpdate={(newAddress) => {
                            formikRef.current?.setValues({
                              ...values,
                              emergencyContact: {
                                ...values.emergencyContact,
                                address: newAddress,
                              },
                            });
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Card>

                  <Box>
                    <Grid
                      className="flex__ justifyContent-FlexEnd pt-md pb-xlg "
                      container
                      direction="row"
                      alignItems="right"
                    >
                      <Grid item>
                        <ButtonComponent
                          className="btn-primary btn-cancel btn_width_90px mr-md"
                          variantType="outlined"
                          labelId="cancelText"
                          defaultLabelId="Cancel"
                          onClick={() => {
                            if (_.isEqual(originalEmployeeData, values)) {
                              navigate(
                                screenFrom === 'employeeList'
                                  ? EMPLOYEES_ROUTE_NAME
                                  : PROFILE_ROUTE_NAME,
                              );
                            } else {
                              setOpenModal(true);
                            }
                          }}
                        />

                        <ButtonComponent
                          className="btn-primary btn-submit"
                          variantType="contained"
                          labelId="Insurance.update"
                          defaultLabelId="Update"
                          onClick={() => {
                            const keysToCheck: (keyof EmployeeFormData)[] = [
                              'employeeTypeStartDate',
                              'productivityGoalStartDate',
                              'workingHoursPerWeekStartDate',
                              'workingHours',
                              'productivityGoal',
                              'employeeType',
                              'programs',
                            ];

                            for (const key of keysToCheck) {
                              if (key === 'programs') {
                                const originalPrograms =
                                  originalEmployeeData.programs || [];
                                const currentPrograms =
                                  formikRef.current?.values.programs || [];

                                // check each program's endDate
                                for (
                                  let i = 0;
                                  i < originalPrograms.length;
                                  i++
                                ) {
                                  if (
                                    originalPrograms[i].programEndDate !==
                                    currentPrograms[i].programEndDate
                                  ) {
                                    isProgramEndDateChange = true;
                                    break;
                                  }
                                }
                              } else if (
                                originalEmployeeData[key] !==
                                formikRef.current?.values[key]
                              ) {
                                isActivitySheetCheckRequiredDataChange = true;
                              }
                            }

                            handleSubmit();
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              );
            }}
          </Formik>
        </Box>
        <ModalPopup
          open={openModal}
          description="formUnsavedChangesMessage"
          onCancel={() => setOpenModal(false)}
          onOk={() => {
            clearForm();
          }}
          labelId1="Clientpage.cancelbtn"
          negativeActionLabel="Cancel"
          labelId2="Clientpage.Okbtn"
          positiveActionLabel="Ok"
        />
      </Box>
    </Box>
  ) : (
    <div></div>
  );
};

export default EditEmployeeScreen;
